import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQrCode = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 144,
	height: 144,
	viewBox: "0 0 144 144",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 9.83415C37.4598 9.83415 37.9315 9.36242 37.9315 8.7805C37.9315 8.19858 37.4598 7.72684 36.8779 7.72684C36.296 7.72684 35.8242 8.19858 35.8242 8.7805C35.8242 9.36242 36.296 9.83415 36.8779 9.83415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 9.83415C40.9715 9.83415 41.4433 9.36242 41.4433 8.7805C41.4433 8.19858 40.9715 7.72684 40.3896 7.72684C39.8077 7.72684 39.3359 8.19858 39.3359 8.7805C39.3359 9.36242 39.8077 9.83415 40.3896 9.83415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 9.83415C58.534 9.83415 59.0058 9.36242 59.0058 8.7805C59.0058 8.19858 58.534 7.72684 57.9521 7.72684C57.3702 7.72684 56.8984 8.19858 56.8984 8.7805C56.8984 9.36242 57.3702 9.83415 57.9521 9.83415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 9.83415C65.5575 9.83415 66.0292 9.36242 66.0292 8.7805C66.0292 8.19858 65.5575 7.72684 64.9755 7.72684C64.3936 7.72684 63.9219 8.19858 63.9219 8.7805C63.9219 9.36242 64.3936 9.83415 64.9755 9.83415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 9.83415C72.5828 9.83415 73.0546 9.36242 73.0546 8.7805C73.0546 8.19858 72.5828 7.72684 72.0009 7.72684C71.419 7.72684 70.9473 8.19858 70.9473 8.7805C70.9473 9.36242 71.419 9.83415 72.0009 9.83415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 9.83415C79.6063 9.83415 80.078 9.36242 80.078 8.7805C80.078 8.19858 79.6063 7.72684 79.0244 7.72684C78.4424 7.72684 77.9707 8.19858 77.9707 8.7805C77.9707 9.36242 78.4424 9.83415 79.0244 9.83415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 9.83415C83.118 9.83415 83.5897 9.36242 83.5897 8.7805C83.5897 8.19858 83.118 7.72684 82.5361 7.72684C81.9542 7.72684 81.4824 8.19858 81.4824 8.7805C81.4824 9.36242 81.9542 9.83415 82.5361 9.83415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 9.83415C90.1434 9.83415 90.6151 9.36242 90.6151 8.7805C90.6151 8.19858 90.1434 7.72684 89.5615 7.72684C88.9796 7.72684 88.5078 8.19858 88.5078 8.7805C88.5078 9.36242 88.9796 9.83415 89.5615 9.83415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 9.83415C100.679 9.83415 101.15 9.36242 101.15 8.7805C101.15 8.19858 100.679 7.72684 100.097 7.72684C99.5147 7.72684 99.043 8.19858 99.043 8.7805C99.043 9.36242 99.5147 9.83415 100.097 9.83415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 9.83415C107.704 9.83415 108.176 9.36242 108.176 8.7805C108.176 8.19858 107.704 7.72684 107.122 7.72684C106.54 7.72684 106.068 8.19858 106.068 8.7805C106.068 9.36242 106.54 9.83415 107.122 9.83415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 13.3463C37.4598 13.3463 37.9315 12.8746 37.9315 12.2927C37.9315 11.7108 37.4598 11.239 36.8779 11.239C36.296 11.239 35.8242 11.7108 35.8242 12.2927C35.8242 12.8746 36.296 13.3463 36.8779 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 13.3463C40.9715 13.3463 41.4433 12.8746 41.4433 12.2927C41.4433 11.7108 40.9715 11.239 40.3896 11.239C39.8077 11.239 39.3359 11.7108 39.3359 12.2927C39.3359 12.8746 39.8077 13.3463 40.3896 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 13.3463C44.4852 13.3463 44.9569 12.8746 44.9569 12.2927C44.9569 11.7108 44.4852 11.239 43.9033 11.239C43.3213 11.239 42.8496 11.7108 42.8496 12.2927C42.8496 12.8746 43.3213 13.3463 43.9033 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 13.3463C47.9969 13.3463 48.4686 12.8746 48.4686 12.2927C48.4686 11.7108 47.9969 11.239 47.415 11.239C46.8331 11.239 46.3613 11.7108 46.3613 12.2927C46.3613 12.8746 46.8331 13.3463 47.415 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 13.3463C58.534 13.3463 59.0058 12.8746 59.0058 12.2927C59.0058 11.7108 58.534 11.239 57.9521 11.239C57.3702 11.239 56.8984 11.7108 56.8984 12.2927C56.8984 12.8746 57.3702 13.3463 57.9521 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 13.3463C65.5575 13.3463 66.0292 12.8746 66.0292 12.2927C66.0292 11.7108 65.5575 11.239 64.9755 11.239C64.3936 11.239 63.9219 11.7108 63.9219 12.2927C63.9219 12.8746 64.3936 13.3463 64.9755 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 13.3463C69.0692 13.3463 69.5409 12.8746 69.5409 12.2927C69.5409 11.7108 69.0692 11.239 68.4873 11.239C67.9053 11.239 67.4336 11.7108 67.4336 12.2927C67.4336 12.8746 67.9053 13.3463 68.4873 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 13.3463C72.5828 13.3463 73.0546 12.8746 73.0546 12.2927C73.0546 11.7108 72.5828 11.239 72.0009 11.239C71.419 11.239 70.9473 11.7108 70.9473 12.2927C70.9473 12.8746 71.419 13.3463 72.0009 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 13.3463C76.0946 13.3463 76.5663 12.8746 76.5663 12.2927C76.5663 11.7108 76.0946 11.239 75.5126 11.239C74.9307 11.239 74.459 11.7108 74.459 12.2927C74.459 12.8746 74.9307 13.3463 75.5126 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 13.3463C79.6063 13.3463 80.078 12.8746 80.078 12.2927C80.078 11.7108 79.6063 11.239 79.0244 11.239C78.4424 11.239 77.9707 11.7108 77.9707 12.2927C77.9707 12.8746 78.4424 13.3463 79.0244 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 13.3463C83.118 13.3463 83.5897 12.8746 83.5897 12.2927C83.5897 11.7108 83.118 11.239 82.5361 11.239C81.9542 11.239 81.4824 11.7108 81.4824 12.2927C81.4824 12.8746 81.9542 13.3463 82.5361 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 13.3463C90.1434 13.3463 90.6151 12.8746 90.6151 12.2927C90.6151 11.7108 90.1434 11.239 89.5615 11.239C88.9796 11.239 88.5078 11.7108 88.5078 12.2927C88.5078 12.8746 88.9796 13.3463 89.5615 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 13.3463C93.6551 13.3463 94.1268 12.8746 94.1268 12.2927C94.1268 11.7108 93.6551 11.239 93.0732 11.239C92.4913 11.239 92.0195 11.7108 92.0195 12.2927C92.0195 12.8746 92.4913 13.3463 93.0732 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 13.3463C100.679 13.3463 101.15 12.8746 101.15 12.2927C101.15 11.7108 100.679 11.239 100.097 11.239C99.5147 11.239 99.043 11.7108 99.043 12.2927C99.043 12.8746 99.5147 13.3463 100.097 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 13.3463C107.704 13.3463 108.176 12.8746 108.176 12.2927C108.176 11.7108 107.704 11.239 107.122 11.239C106.54 11.239 106.068 11.7108 106.068 12.2927C106.068 12.8746 106.54 13.3463 107.122 13.3463Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 16.8585C65.5575 16.8585 66.0292 16.3868 66.0292 15.8049C66.0292 15.223 65.5575 14.7512 64.9755 14.7512C64.3936 14.7512 63.9219 15.223 63.9219 15.8049C63.9219 16.3868 64.3936 16.8585 64.9755 16.8585Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 16.8585C79.6063 16.8585 80.078 16.3868 80.078 15.8049C80.078 15.223 79.6063 14.7512 79.0244 14.7512C78.4424 14.7512 77.9707 15.223 77.9707 15.8049C77.9707 16.3868 78.4424 16.8585 79.0244 16.8585Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 16.8585C93.6551 16.8585 94.1268 16.3868 94.1268 15.8049C94.1268 15.223 93.6551 14.7512 93.0732 14.7512C92.4913 14.7512 92.0195 15.223 92.0195 15.8049C92.0195 16.3868 92.4913 16.8585 93.0732 16.8585Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 16.8585C97.1668 16.8585 97.6386 16.3868 97.6386 15.8049C97.6386 15.223 97.1668 14.7512 96.5849 14.7512C96.003 14.7512 95.5312 15.223 95.5312 15.8049C95.5312 16.3868 96.003 16.8585 96.5849 16.8585Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 16.8585C104.192 16.8585 104.664 16.3868 104.664 15.8049C104.664 15.223 104.192 14.7512 103.61 14.7512C103.028 14.7512 102.557 15.223 102.557 15.8049C102.557 16.3868 103.028 16.8585 103.61 16.8585Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 20.3707C37.4598 20.3707 37.9315 19.899 37.9315 19.3171C37.9315 18.7352 37.4598 18.2634 36.8779 18.2634C36.296 18.2634 35.8242 18.7352 35.8242 19.3171C35.8242 19.899 36.296 20.3707 36.8779 20.3707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 20.3707C47.9969 20.3707 48.4686 19.899 48.4686 19.3171C48.4686 18.7352 47.9969 18.2634 47.415 18.2634C46.8331 18.2634 46.3613 18.7352 46.3613 19.3171C46.3613 19.899 46.8331 20.3707 47.415 20.3707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 20.3707C55.0203 20.3707 55.4921 19.899 55.4921 19.3171C55.4921 18.7352 55.0203 18.2634 54.4384 18.2634C53.8565 18.2634 53.3848 18.7352 53.3848 19.3171C53.3848 19.899 53.8565 20.3707 54.4384 20.3707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 20.3707C58.534 20.3707 59.0058 19.899 59.0058 19.3171C59.0058 18.7352 58.534 18.2634 57.9521 18.2634C57.3702 18.2634 56.8984 18.7352 56.8984 19.3171C56.8984 19.899 57.3702 20.3707 57.9521 20.3707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 20.3707C62.0457 20.3707 62.5175 19.899 62.5175 19.3171C62.5175 18.7352 62.0457 18.2634 61.4638 18.2634C60.8819 18.2634 60.4102 18.7352 60.4102 19.3171C60.4102 19.899 60.8819 20.3707 61.4638 20.3707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 20.3707C69.0692 20.3707 69.5409 19.899 69.5409 19.3171C69.5409 18.7352 69.0692 18.2634 68.4873 18.2634C67.9053 18.2634 67.4336 18.7352 67.4336 19.3171C67.4336 19.899 67.9053 20.3707 68.4873 20.3707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 20.3707C76.0946 20.3707 76.5663 19.899 76.5663 19.3171C76.5663 18.7352 76.0946 18.2634 75.5126 18.2634C74.9307 18.2634 74.459 18.7352 74.459 19.3171C74.459 19.899 74.9307 20.3707 75.5126 20.3707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 20.3707C90.1434 20.3707 90.6151 19.899 90.6151 19.3171C90.6151 18.7352 90.1434 18.2634 89.5615 18.2634C88.9796 18.2634 88.5078 18.7352 88.5078 19.3171C88.5078 19.899 88.9796 20.3707 89.5615 20.3707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 20.3707C97.1668 20.3707 97.6386 19.899 97.6386 19.3171C97.6386 18.7352 97.1668 18.2634 96.5849 18.2634C96.003 18.2634 95.5312 18.7352 95.5312 19.3171C95.5312 19.899 96.003 20.3707 96.5849 20.3707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 20.3707C100.679 20.3707 101.15 19.899 101.15 19.3171C101.15 18.7352 100.679 18.2634 100.097 18.2634C99.5147 18.2634 99.043 18.7352 99.043 19.3171C99.043 19.899 99.5147 20.3707 100.097 20.3707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 20.3707C107.704 20.3707 108.176 19.899 108.176 19.3171C108.176 18.7352 107.704 18.2634 107.122 18.2634C106.54 18.2634 106.068 18.7352 106.068 19.3171C106.068 19.899 106.54 20.3707 107.122 20.3707Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 23.8829C40.9715 23.8829 41.4433 23.4112 41.4433 22.8293C41.4433 22.2473 40.9715 21.7756 40.3896 21.7756C39.8077 21.7756 39.3359 22.2473 39.3359 22.8293C39.3359 23.4112 39.8077 23.8829 40.3896 23.8829Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 23.8829C47.9969 23.8829 48.4686 23.4112 48.4686 22.8293C48.4686 22.2473 47.9969 21.7756 47.415 21.7756C46.8331 21.7756 46.3613 22.2473 46.3613 22.8293C46.3613 23.4112 46.8331 23.8829 47.415 23.8829Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 23.8829C51.5086 23.8829 51.9804 23.4112 51.9804 22.8293C51.9804 22.2473 51.5086 21.7756 50.9267 21.7756C50.3448 21.7756 49.873 22.2473 49.873 22.8293C49.873 23.4112 50.3448 23.8829 50.9267 23.8829Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 23.8829C69.0692 23.8829 69.5409 23.4112 69.5409 22.8293C69.5409 22.2473 69.0692 21.7756 68.4873 21.7756C67.9053 21.7756 67.4336 22.2473 67.4336 22.8293C67.4336 23.4112 67.9053 23.8829 68.4873 23.8829Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 23.8829C72.5828 23.8829 73.0546 23.4112 73.0546 22.8293C73.0546 22.2473 72.5828 21.7756 72.0009 21.7756C71.419 21.7756 70.9473 22.2473 70.9473 22.8293C70.9473 23.4112 71.419 23.8829 72.0009 23.8829Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 23.8829C76.0946 23.8829 76.5663 23.4112 76.5663 22.8293C76.5663 22.2473 76.0946 21.7756 75.5126 21.7756C74.9307 21.7756 74.459 22.2473 74.459 22.8293C74.459 23.4112 74.9307 23.8829 75.5126 23.8829Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 23.8829C83.118 23.8829 83.5897 23.4112 83.5897 22.8293C83.5897 22.2473 83.118 21.7756 82.5361 21.7756C81.9542 21.7756 81.4824 22.2473 81.4824 22.8293C81.4824 23.4112 81.9542 23.8829 82.5361 23.8829Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 23.8829C93.6551 23.8829 94.1268 23.4112 94.1268 22.8293C94.1268 22.2473 93.6551 21.7756 93.0732 21.7756C92.4913 21.7756 92.0195 22.2473 92.0195 22.8293C92.0195 23.4112 92.4913 23.8829 93.0732 23.8829Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 23.8829C100.679 23.8829 101.15 23.4112 101.15 22.8293C101.15 22.2473 100.679 21.7756 100.097 21.7756C99.5147 21.7756 99.043 22.2473 99.043 22.8293C99.043 23.4112 99.5147 23.8829 100.097 23.8829Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 23.8829C104.192 23.8829 104.664 23.4112 104.664 22.8293C104.664 22.2473 104.192 21.7756 103.61 21.7756C103.028 21.7756 102.557 22.2473 102.557 22.8293C102.557 23.4112 103.028 23.8829 103.61 23.8829Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 23.8829C107.704 23.8829 108.176 23.4112 108.176 22.8293C108.176 22.2473 107.704 21.7756 107.122 21.7756C106.54 21.7756 106.068 22.2473 106.068 22.8293C106.068 23.4112 106.54 23.8829 107.122 23.8829Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 27.3951C44.4852 27.3951 44.9569 26.9234 44.9569 26.3415C44.9569 25.7596 44.4852 25.2878 43.9033 25.2878C43.3213 25.2878 42.8496 25.7596 42.8496 26.3415C42.8496 26.9234 43.3213 27.3951 43.9033 27.3951Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 27.3951C55.0203 27.3951 55.4921 26.9234 55.4921 26.3415C55.4921 25.7596 55.0203 25.2878 54.4384 25.2878C53.8565 25.2878 53.3848 25.7596 53.3848 26.3415C53.3848 26.9234 53.8565 27.3951 54.4384 27.3951Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 27.3951C62.0457 27.3951 62.5175 26.9234 62.5175 26.3415C62.5175 25.7596 62.0457 25.2878 61.4638 25.2878C60.8819 25.2878 60.4102 25.7596 60.4102 26.3415C60.4102 26.9234 60.8819 27.3951 61.4638 27.3951Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 27.3951C76.0946 27.3951 76.5663 26.9234 76.5663 26.3415C76.5663 25.7596 76.0946 25.2878 75.5126 25.2878C74.9307 25.2878 74.459 25.7596 74.459 26.3415C74.459 26.9234 74.9307 27.3951 75.5126 27.3951Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 27.3951C86.6317 27.3951 87.1034 26.9234 87.1034 26.3415C87.1034 25.7596 86.6317 25.2878 86.0498 25.2878C85.4678 25.2878 84.9961 25.7596 84.9961 26.3415C84.9961 26.9234 85.4678 27.3951 86.0498 27.3951Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 27.3951C93.6551 27.3951 94.1268 26.9234 94.1268 26.3415C94.1268 25.7596 93.6551 25.2878 93.0732 25.2878C92.4913 25.2878 92.0195 25.7596 92.0195 26.3415C92.0195 26.9234 92.4913 27.3951 93.0732 27.3951Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 27.3951C97.1668 27.3951 97.6386 26.9234 97.6386 26.3415C97.6386 25.7596 97.1668 25.2878 96.5849 25.2878C96.003 25.2878 95.5312 25.7596 95.5312 26.3415C95.5312 26.9234 96.003 27.3951 96.5849 27.3951Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 27.3951C107.704 27.3951 108.176 26.9234 108.176 26.3415C108.176 25.7596 107.704 25.2878 107.122 25.2878C106.54 25.2878 106.068 25.7596 106.068 26.3415C106.068 26.9234 106.54 27.3951 107.122 27.3951Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 30.9073C37.4598 30.9073 37.9315 30.4356 37.9315 29.8536C37.9315 29.2717 37.4598 28.8 36.8779 28.8C36.296 28.8 35.8242 29.2717 35.8242 29.8536C35.8242 30.4356 36.296 30.9073 36.8779 30.9073Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 30.9073C44.4852 30.9073 44.9569 30.4356 44.9569 29.8536C44.9569 29.2717 44.4852 28.8 43.9033 28.8C43.3213 28.8 42.8496 29.2717 42.8496 29.8536C42.8496 30.4356 43.3213 30.9073 43.9033 30.9073Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 30.9073C51.5086 30.9073 51.9804 30.4356 51.9804 29.8536C51.9804 29.2717 51.5086 28.8 50.9267 28.8C50.3448 28.8 49.873 29.2717 49.873 29.8536C49.873 30.4356 50.3448 30.9073 50.9267 30.9073Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 30.9073C58.534 30.9073 59.0058 30.4356 59.0058 29.8536C59.0058 29.2717 58.534 28.8 57.9521 28.8C57.3702 28.8 56.8984 29.2717 56.8984 29.8536C56.8984 30.4356 57.3702 30.9073 57.9521 30.9073Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 30.9073C65.5575 30.9073 66.0292 30.4356 66.0292 29.8536C66.0292 29.2717 65.5575 28.8 64.9755 28.8C64.3936 28.8 63.9219 29.2717 63.9219 29.8536C63.9219 30.4356 64.3936 30.9073 64.9755 30.9073Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 30.9073C72.5828 30.9073 73.0546 30.4356 73.0546 29.8536C73.0546 29.2717 72.5828 28.8 72.0009 28.8C71.419 28.8 70.9473 29.2717 70.9473 29.8536C70.9473 30.4356 71.419 30.9073 72.0009 30.9073Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 30.9073C79.6063 30.9073 80.078 30.4356 80.078 29.8536C80.078 29.2717 79.6063 28.8 79.0244 28.8C78.4424 28.8 77.9707 29.2717 77.9707 29.8536C77.9707 30.4356 78.4424 30.9073 79.0244 30.9073Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 30.9073C86.6317 30.9073 87.1034 30.4356 87.1034 29.8536C87.1034 29.2717 86.6317 28.8 86.0498 28.8C85.4678 28.8 84.9961 29.2717 84.9961 29.8536C84.9961 30.4356 85.4678 30.9073 86.0498 30.9073Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 30.9073C93.6551 30.9073 94.1268 30.4356 94.1268 29.8536C94.1268 29.2717 93.6551 28.8 93.0732 28.8C92.4913 28.8 92.0195 29.2717 92.0195 29.8536C92.0195 30.4356 92.4913 30.9073 93.0732 30.9073Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 30.9073C100.679 30.9073 101.15 30.4356 101.15 29.8536C101.15 29.2717 100.679 28.8 100.097 28.8C99.5147 28.8 99.043 29.2717 99.043 29.8536C99.043 30.4356 99.5147 30.9073 100.097 30.9073Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 30.9073C107.704 30.9073 108.176 30.4356 108.176 29.8536C108.176 29.2717 107.704 28.8 107.122 28.8C106.54 28.8 106.068 29.2717 106.068 29.8536C106.068 30.4356 106.54 30.9073 107.122 30.9073Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 34.4195C37.4598 34.4195 37.9315 33.9478 37.9315 33.3659C37.9315 32.7839 37.4598 32.3122 36.8779 32.3122C36.296 32.3122 35.8242 32.7839 35.8242 33.3659C35.8242 33.9478 36.296 34.4195 36.8779 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 34.4195C51.5086 34.4195 51.9804 33.9478 51.9804 33.3659C51.9804 32.7839 51.5086 32.3122 50.9267 32.3122C50.3448 32.3122 49.873 32.7839 49.873 33.3659C49.873 33.9478 50.3448 34.4195 50.9267 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 34.4195C58.534 34.4195 59.0058 33.9478 59.0058 33.3659C59.0058 32.7839 58.534 32.3122 57.9521 32.3122C57.3702 32.3122 56.8984 32.7839 56.8984 33.3659C56.8984 33.9478 57.3702 34.4195 57.9521 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 34.4195C65.5575 34.4195 66.0292 33.9478 66.0292 33.3659C66.0292 32.7839 65.5575 32.3122 64.9755 32.3122C64.3936 32.3122 63.9219 32.7839 63.9219 33.3659C63.9219 33.9478 64.3936 34.4195 64.9755 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 34.4195C69.0692 34.4195 69.5409 33.9478 69.5409 33.3659C69.5409 32.7839 69.0692 32.3122 68.4873 32.3122C67.9053 32.3122 67.4336 32.7839 67.4336 33.3659C67.4336 33.9478 67.9053 34.4195 68.4873 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 34.4195C72.5828 34.4195 73.0546 33.9478 73.0546 33.3659C73.0546 32.7839 72.5828 32.3122 72.0009 32.3122C71.419 32.3122 70.9473 32.7839 70.9473 33.3659C70.9473 33.9478 71.419 34.4195 72.0009 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 34.4195C76.0946 34.4195 76.5663 33.9478 76.5663 33.3659C76.5663 32.7839 76.0946 32.3122 75.5126 32.3122C74.9307 32.3122 74.459 32.7839 74.459 33.3659C74.459 33.9478 74.9307 34.4195 75.5126 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 34.4195C79.6063 34.4195 80.078 33.9478 80.078 33.3659C80.078 32.7839 79.6063 32.3122 79.0244 32.3122C78.4424 32.3122 77.9707 32.7839 77.9707 33.3659C77.9707 33.9478 78.4424 34.4195 79.0244 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 34.4195C86.6317 34.4195 87.1034 33.9478 87.1034 33.3659C87.1034 32.7839 86.6317 32.3122 86.0498 32.3122C85.4678 32.3122 84.9961 32.7839 84.9961 33.3659C84.9961 33.9478 85.4678 34.4195 86.0498 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 34.4195C90.1434 34.4195 90.6151 33.9478 90.6151 33.3659C90.6151 32.7839 90.1434 32.3122 89.5615 32.3122C88.9796 32.3122 88.5078 32.7839 88.5078 33.3659C88.5078 33.9478 88.9796 34.4195 89.5615 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 34.4195C93.6551 34.4195 94.1268 33.9478 94.1268 33.3659C94.1268 32.7839 93.6551 32.3122 93.0732 32.3122C92.4913 32.3122 92.0195 32.7839 92.0195 33.3659C92.0195 33.9478 92.4913 34.4195 93.0732 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 34.4195C100.679 34.4195 101.15 33.9478 101.15 33.3659C101.15 32.7839 100.679 32.3122 100.097 32.3122C99.5147 32.3122 99.043 32.7839 99.043 33.3659C99.043 33.9478 99.5147 34.4195 100.097 34.4195Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78022 37.9317C9.36214 37.9317 9.83388 37.46 9.83388 36.8781C9.83388 36.2961 9.36214 35.8244 8.78022 35.8244C8.1983 35.8244 7.72656 36.2961 7.72656 36.8781C7.72656 37.46 8.1983 37.9317 8.78022 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8056 37.9317C16.3875 37.9317 16.8593 37.46 16.8593 36.8781C16.8593 36.2961 16.3875 35.8244 15.8056 35.8244C15.2237 35.8244 14.752 36.2961 14.752 36.8781C14.752 37.46 15.2237 37.9317 15.8056 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3173 37.9317C19.8992 37.9317 20.371 37.46 20.371 36.8781C20.371 36.2961 19.8992 35.8244 19.3173 35.8244C18.7354 35.8244 18.2637 36.2961 18.2637 36.8781C18.2637 37.46 18.7354 37.9317 19.3173 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 37.9317C26.9227 37.9317 27.3944 37.46 27.3944 36.8781C27.3944 36.2961 26.9227 35.8244 26.3408 35.8244C25.7588 35.8244 25.2871 36.2961 25.2871 36.8781C25.2871 37.46 25.7588 37.9317 26.3408 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8544 37.9317C30.4364 37.9317 30.9081 37.46 30.9081 36.8781C30.9081 36.2961 30.4364 35.8244 29.8544 35.8244C29.2725 35.8244 28.8008 36.2961 28.8008 36.8781C28.8008 37.46 29.2725 37.9317 29.8544 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 37.9317C33.9481 37.9317 34.4198 37.46 34.4198 36.8781C34.4198 36.2961 33.9481 35.8244 33.3662 35.8244C32.7842 35.8244 32.3125 36.2961 32.3125 36.8781C32.3125 37.46 32.7842 37.9317 33.3662 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 37.9317C47.9969 37.9317 48.4686 37.46 48.4686 36.8781C48.4686 36.2961 47.9969 35.8244 47.415 35.8244C46.8331 35.8244 46.3613 36.2961 46.3613 36.8781C46.3613 37.46 46.8331 37.9317 47.415 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 37.9317C51.5086 37.9317 51.9804 37.46 51.9804 36.8781C51.9804 36.2961 51.5086 35.8244 50.9267 35.8244C50.3448 35.8244 49.873 36.2961 49.873 36.8781C49.873 37.46 50.3448 37.9317 50.9267 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 37.9317C55.0203 37.9317 55.4921 37.46 55.4921 36.8781C55.4921 36.2961 55.0203 35.8244 54.4384 35.8244C53.8565 35.8244 53.3848 36.2961 53.3848 36.8781C53.3848 37.46 53.8565 37.9317 54.4384 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 37.9317C62.0457 37.9317 62.5175 37.46 62.5175 36.8781C62.5175 36.2961 62.0457 35.8244 61.4638 35.8244C60.8819 35.8244 60.4102 36.2961 60.4102 36.8781C60.4102 37.46 60.8819 37.9317 61.4638 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 37.9317C65.5575 37.9317 66.0292 37.46 66.0292 36.8781C66.0292 36.2961 65.5575 35.8244 64.9755 35.8244C64.3936 35.8244 63.9219 36.2961 63.9219 36.8781C63.9219 37.46 64.3936 37.9317 64.9755 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 37.9317C76.0946 37.9317 76.5663 37.46 76.5663 36.8781C76.5663 36.2961 76.0946 35.8244 75.5126 35.8244C74.9307 35.8244 74.459 36.2961 74.459 36.8781C74.459 37.46 74.9307 37.9317 75.5126 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 37.9317C79.6063 37.9317 80.078 37.46 80.078 36.8781C80.078 36.2961 79.6063 35.8244 79.0244 35.8244C78.4424 35.8244 77.9707 36.2961 77.9707 36.8781C77.9707 37.46 78.4424 37.9317 79.0244 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 37.9317C83.118 37.9317 83.5897 37.46 83.5897 36.8781C83.5897 36.2961 83.118 35.8244 82.5361 35.8244C81.9542 35.8244 81.4824 36.2961 81.4824 36.8781C81.4824 37.46 81.9542 37.9317 82.5361 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 37.9317C93.6551 37.9317 94.1268 37.46 94.1268 36.8781C94.1268 36.2961 93.6551 35.8244 93.0732 35.8244C92.4913 35.8244 92.0195 36.2961 92.0195 36.8781C92.0195 37.46 92.4913 37.9317 93.0732 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 37.9317C100.679 37.9317 101.15 37.46 101.15 36.8781C101.15 36.2961 100.679 35.8244 100.097 35.8244C99.5147 35.8244 99.043 36.2961 99.043 36.8781C99.043 37.46 99.5147 37.9317 100.097 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 37.9317C114.727 37.9317 115.199 37.46 115.199 36.8781C115.199 36.2961 114.727 35.8244 114.145 35.8244C113.564 35.8244 113.092 36.2961 113.092 36.8781C113.092 37.46 113.564 37.9317 114.145 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 37.9317C125.264 37.9317 125.736 37.46 125.736 36.8781C125.736 36.2961 125.264 35.8244 124.683 35.8244C124.101 35.8244 123.629 36.2961 123.629 36.8781C123.629 37.46 124.101 37.9317 124.683 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 37.9317C132.29 37.9317 132.762 37.46 132.762 36.8781C132.762 36.2961 132.29 35.8244 131.708 35.8244C131.126 35.8244 130.654 36.2961 130.654 36.8781C130.654 37.46 131.126 37.9317 131.708 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 37.9317C135.802 37.9317 136.273 37.46 136.273 36.8781C136.273 36.2961 135.802 35.8244 135.22 35.8244C134.638 35.8244 134.166 36.2961 134.166 36.8781C134.166 37.46 134.638 37.9317 135.22 37.9317Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8056 41.4439C16.3875 41.4439 16.8593 40.9722 16.8593 40.3902C16.8593 39.8083 16.3875 39.3366 15.8056 39.3366C15.2237 39.3366 14.752 39.8083 14.752 40.3902C14.752 40.9722 15.2237 41.4439 15.8056 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3173 41.4439C19.8992 41.4439 20.371 40.9722 20.371 40.3902C20.371 39.8083 19.8992 39.3366 19.3173 39.3366C18.7354 39.3366 18.2637 39.8083 18.2637 40.3902C18.2637 40.9722 18.7354 41.4439 19.3173 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 41.4439C33.9481 41.4439 34.4198 40.9722 34.4198 40.3902C34.4198 39.8083 33.9481 39.3366 33.3662 39.3366C32.7842 39.3366 32.3125 39.8083 32.3125 40.3902C32.3125 40.9722 32.7842 41.4439 33.3662 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 41.4439C40.9715 41.4439 41.4433 40.9722 41.4433 40.3902C41.4433 39.8083 40.9715 39.3366 40.3896 39.3366C39.8077 39.3366 39.3359 39.8083 39.3359 40.3902C39.3359 40.9722 39.8077 41.4439 40.3896 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 41.4439C44.4852 41.4439 44.9569 40.9722 44.9569 40.3902C44.9569 39.8083 44.4852 39.3366 43.9033 39.3366C43.3213 39.3366 42.8496 39.8083 42.8496 40.3902C42.8496 40.9722 43.3213 41.4439 43.9033 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 41.4439C47.9969 41.4439 48.4686 40.9722 48.4686 40.3902C48.4686 39.8083 47.9969 39.3366 47.415 39.3366C46.8331 39.3366 46.3613 39.8083 46.3613 40.3902C46.3613 40.9722 46.8331 41.4439 47.415 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 41.4439C51.5086 41.4439 51.9804 40.9722 51.9804 40.3902C51.9804 39.8083 51.5086 39.3366 50.9267 39.3366C50.3448 39.3366 49.873 39.8083 49.873 40.3902C49.873 40.9722 50.3448 41.4439 50.9267 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 41.4439C62.0457 41.4439 62.5175 40.9722 62.5175 40.3902C62.5175 39.8083 62.0457 39.3366 61.4638 39.3366C60.8819 39.3366 60.4102 39.8083 60.4102 40.3902C60.4102 40.9722 60.8819 41.4439 61.4638 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 41.4439C65.5575 41.4439 66.0292 40.9722 66.0292 40.3902C66.0292 39.8083 65.5575 39.3366 64.9755 39.3366C64.3936 39.3366 63.9219 39.8083 63.9219 40.3902C63.9219 40.9722 64.3936 41.4439 64.9755 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 41.4439C86.6317 41.4439 87.1034 40.9722 87.1034 40.3902C87.1034 39.8083 86.6317 39.3366 86.0498 39.3366C85.4678 39.3366 84.9961 39.8083 84.9961 40.3902C84.9961 40.9722 85.4678 41.4439 86.0498 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 41.4439C90.1434 41.4439 90.6151 40.9722 90.6151 40.3902C90.6151 39.8083 90.1434 39.3366 89.5615 39.3366C88.9796 39.3366 88.5078 39.8083 88.5078 40.3902C88.5078 40.9722 88.9796 41.4439 89.5615 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 41.4439C93.6551 41.4439 94.1268 40.9722 94.1268 40.3902C94.1268 39.8083 93.6551 39.3366 93.0732 39.3366C92.4913 39.3366 92.0195 39.8083 92.0195 40.3902C92.0195 40.9722 92.4913 41.4439 93.0732 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 41.4439C97.1668 41.4439 97.6386 40.9722 97.6386 40.3902C97.6386 39.8083 97.1668 39.3366 96.5849 39.3366C96.003 39.3366 95.5312 39.8083 95.5312 40.3902C95.5312 40.9722 96.003 41.4439 96.5849 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 41.4439C111.216 41.4439 111.687 40.9722 111.687 40.3902C111.687 39.8083 111.216 39.3366 110.634 39.3366C110.052 39.3366 109.58 39.8083 109.58 40.3902C109.58 40.9722 110.052 41.4439 110.634 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 41.4439C128.776 41.4439 129.248 40.9722 129.248 40.3902C129.248 39.8083 128.776 39.3366 128.194 39.3366C127.612 39.3366 127.141 39.8083 127.141 40.3902C127.141 40.9722 127.612 41.4439 128.194 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 41.4439C132.29 41.4439 132.762 40.9722 132.762 40.3902C132.762 39.8083 132.29 39.3366 131.708 39.3366C131.126 39.3366 130.654 39.8083 130.654 40.3902C130.654 40.9722 131.126 41.4439 131.708 41.4439Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2919 44.9561C12.8739 44.9561 13.3456 44.4844 13.3456 43.9024C13.3456 43.3205 12.8739 42.8488 12.2919 42.8488C11.71 42.8488 11.2383 43.3205 11.2383 43.9024C11.2383 44.4844 11.71 44.9561 12.2919 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8056 44.9561C16.3875 44.9561 16.8593 44.4844 16.8593 43.9024C16.8593 43.3205 16.3875 42.8488 15.8056 42.8488C15.2237 42.8488 14.752 43.3205 14.752 43.9024C14.752 44.4844 15.2237 44.9561 15.8056 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.829 44.9561C23.411 44.9561 23.8827 44.4844 23.8827 43.9024C23.8827 43.3205 23.411 42.8488 22.829 42.8488C22.2471 42.8488 21.7754 43.3205 21.7754 43.9024C21.7754 44.4844 22.2471 44.9561 22.829 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 44.9561C26.9227 44.9561 27.3944 44.4844 27.3944 43.9024C27.3944 43.3205 26.9227 42.8488 26.3408 42.8488C25.7588 42.8488 25.2871 43.3205 25.2871 43.9024C25.2871 44.4844 25.7588 44.9561 26.3408 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8544 44.9561C30.4364 44.9561 30.9081 44.4844 30.9081 43.9024C30.9081 43.3205 30.4364 42.8488 29.8544 42.8488C29.2725 42.8488 28.8008 43.3205 28.8008 43.9024C28.8008 44.4844 29.2725 44.9561 29.8544 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 44.9561C40.9715 44.9561 41.4433 44.4844 41.4433 43.9024C41.4433 43.3205 40.9715 42.8488 40.3896 42.8488C39.8077 42.8488 39.3359 43.3205 39.3359 43.9024C39.3359 44.4844 39.8077 44.9561 40.3896 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 44.9561C51.5086 44.9561 51.9804 44.4844 51.9804 43.9024C51.9804 43.3205 51.5086 42.8488 50.9267 42.8488C50.3448 42.8488 49.873 43.3205 49.873 43.9024C49.873 44.4844 50.3448 44.9561 50.9267 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 44.9561C62.0457 44.9561 62.5175 44.4844 62.5175 43.9024C62.5175 43.3205 62.0457 42.8488 61.4638 42.8488C60.8819 42.8488 60.4102 43.3205 60.4102 43.9024C60.4102 44.4844 60.8819 44.9561 61.4638 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 44.9561C72.5828 44.9561 73.0546 44.4844 73.0546 43.9024C73.0546 43.3205 72.5828 42.8488 72.0009 42.8488C71.419 42.8488 70.9473 43.3205 70.9473 43.9024C70.9473 44.4844 71.419 44.9561 72.0009 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 44.9561C83.118 44.9561 83.5897 44.4844 83.5897 43.9024C83.5897 43.3205 83.118 42.8488 82.5361 42.8488C81.9542 42.8488 81.4824 43.3205 81.4824 43.9024C81.4824 44.4844 81.9542 44.9561 82.5361 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 44.9561C86.6317 44.9561 87.1034 44.4844 87.1034 43.9024C87.1034 43.3205 86.6317 42.8488 86.0498 42.8488C85.4678 42.8488 84.9961 43.3205 84.9961 43.9024C84.9961 44.4844 85.4678 44.9561 86.0498 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 44.9561C90.1434 44.9561 90.6151 44.4844 90.6151 43.9024C90.6151 43.3205 90.1434 42.8488 89.5615 42.8488C88.9796 42.8488 88.5078 43.3205 88.5078 43.9024C88.5078 44.4844 88.9796 44.9561 89.5615 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 44.9561C93.6551 44.9561 94.1268 44.4844 94.1268 43.9024C94.1268 43.3205 93.6551 42.8488 93.0732 42.8488C92.4913 42.8488 92.0195 43.3205 92.0195 43.9024C92.0195 44.4844 92.4913 44.9561 93.0732 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 44.9561C107.704 44.9561 108.176 44.4844 108.176 43.9024C108.176 43.3205 107.704 42.8488 107.122 42.8488C106.54 42.8488 106.068 43.3205 106.068 43.9024C106.068 44.4844 106.54 44.9561 107.122 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 44.9561C111.216 44.9561 111.687 44.4844 111.687 43.9024C111.687 43.3205 111.216 42.8488 110.634 42.8488C110.052 42.8488 109.58 43.3205 109.58 43.9024C109.58 44.4844 110.052 44.9561 110.634 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 44.9561C121.753 44.9561 122.225 44.4844 122.225 43.9024C122.225 43.3205 121.753 42.8488 121.171 42.8488C120.589 42.8488 120.117 43.3205 120.117 43.9024C120.117 44.4844 120.589 44.9561 121.171 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 44.9561C125.264 44.9561 125.736 44.4844 125.736 43.9024C125.736 43.3205 125.264 42.8488 124.683 42.8488C124.101 42.8488 123.629 43.3205 123.629 43.9024C123.629 44.4844 124.101 44.9561 124.683 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 44.9561C128.776 44.9561 129.248 44.4844 129.248 43.9024C129.248 43.3205 128.776 42.8488 128.194 42.8488C127.612 42.8488 127.141 43.3205 127.141 43.9024C127.141 44.4844 127.612 44.9561 128.194 44.9561Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78022 48.4683C9.36214 48.4683 9.83388 47.9965 9.83388 47.4146C9.83388 46.8327 9.36214 46.361 8.78022 46.361C8.1983 46.361 7.72656 46.8327 7.72656 47.4146C7.72656 47.9965 8.1983 48.4683 8.78022 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2919 48.4683C12.8739 48.4683 13.3456 47.9965 13.3456 47.4146C13.3456 46.8327 12.8739 46.361 12.2919 46.361C11.71 46.361 11.2383 46.8327 11.2383 47.4146C11.2383 47.9965 11.71 48.4683 12.2919 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3173 48.4683C19.8992 48.4683 20.371 47.9965 20.371 47.4146C20.371 46.8327 19.8992 46.361 19.3173 46.361C18.7354 46.361 18.2637 46.8327 18.2637 47.4146C18.2637 47.9965 18.7354 48.4683 19.3173 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 48.4683C26.9227 48.4683 27.3944 47.9965 27.3944 47.4146C27.3944 46.8327 26.9227 46.361 26.3408 46.361C25.7588 46.361 25.2871 46.8327 25.2871 47.4146C25.2871 47.9965 25.7588 48.4683 26.3408 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 48.4683C33.9481 48.4683 34.4198 47.9965 34.4198 47.4146C34.4198 46.8327 33.9481 46.361 33.3662 46.361C32.7842 46.361 32.3125 46.8327 32.3125 47.4146C32.3125 47.9965 32.7842 48.4683 33.3662 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 48.4683C37.4598 48.4683 37.9315 47.9965 37.9315 47.4146C37.9315 46.8327 37.4598 46.361 36.8779 46.361C36.296 46.361 35.8242 46.8327 35.8242 47.4146C35.8242 47.9965 36.296 48.4683 36.8779 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 48.4683C47.9969 48.4683 48.4686 47.9965 48.4686 47.4146C48.4686 46.8327 47.9969 46.361 47.415 46.361C46.8331 46.361 46.3613 46.8327 46.3613 47.4146C46.3613 47.9965 46.8331 48.4683 47.415 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 48.4683C51.5086 48.4683 51.9804 47.9965 51.9804 47.4146C51.9804 46.8327 51.5086 46.361 50.9267 46.361C50.3448 46.361 49.873 46.8327 49.873 47.4146C49.873 47.9965 50.3448 48.4683 50.9267 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 48.4683C55.0203 48.4683 55.4921 47.9965 55.4921 47.4146C55.4921 46.8327 55.0203 46.361 54.4384 46.361C53.8565 46.361 53.3848 46.8327 53.3848 47.4146C53.3848 47.9965 53.8565 48.4683 54.4384 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 48.4683C62.0457 48.4683 62.5175 47.9965 62.5175 47.4146C62.5175 46.8327 62.0457 46.361 61.4638 46.361C60.8819 46.361 60.4102 46.8327 60.4102 47.4146C60.4102 47.9965 60.8819 48.4683 61.4638 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 48.4683C72.5828 48.4683 73.0546 47.9965 73.0546 47.4146C73.0546 46.8327 72.5828 46.361 72.0009 46.361C71.419 46.361 70.9473 46.8327 70.9473 47.4146C70.9473 47.9965 71.419 48.4683 72.0009 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 48.4683C76.0946 48.4683 76.5663 47.9965 76.5663 47.4146C76.5663 46.8327 76.0946 46.361 75.5126 46.361C74.9307 46.361 74.459 46.8327 74.459 47.4146C74.459 47.9965 74.9307 48.4683 75.5126 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 48.4683C93.6551 48.4683 94.1268 47.9965 94.1268 47.4146C94.1268 46.8327 93.6551 46.361 93.0732 46.361C92.4913 46.361 92.0195 46.8327 92.0195 47.4146C92.0195 47.9965 92.4913 48.4683 93.0732 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 48.4683C97.1668 48.4683 97.6386 47.9965 97.6386 47.4146C97.6386 46.8327 97.1668 46.361 96.5849 46.361C96.003 46.361 95.5312 46.8327 95.5312 47.4146C95.5312 47.9965 96.003 48.4683 96.5849 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 48.4683C104.192 48.4683 104.664 47.9965 104.664 47.4146C104.664 46.8327 104.192 46.361 103.61 46.361C103.028 46.361 102.557 46.8327 102.557 47.4146C102.557 47.9965 103.028 48.4683 103.61 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 48.4683C111.216 48.4683 111.687 47.9965 111.687 47.4146C111.687 46.8327 111.216 46.361 110.634 46.361C110.052 46.361 109.58 46.8327 109.58 47.4146C109.58 47.9965 110.052 48.4683 110.634 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 48.4683C118.241 48.4683 118.713 47.9965 118.713 47.4146C118.713 46.8327 118.241 46.361 117.659 46.361C117.077 46.361 116.605 46.8327 116.605 47.4146C116.605 47.9965 117.077 48.4683 117.659 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 48.4683C121.753 48.4683 122.225 47.9965 122.225 47.4146C122.225 46.8327 121.753 46.361 121.171 46.361C120.589 46.361 120.117 46.8327 120.117 47.4146C120.117 47.9965 120.589 48.4683 121.171 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 48.4683C125.264 48.4683 125.736 47.9965 125.736 47.4146C125.736 46.8327 125.264 46.361 124.683 46.361C124.101 46.361 123.629 46.8327 123.629 47.4146C123.629 47.9965 124.101 48.4683 124.683 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 48.4683C128.776 48.4683 129.248 47.9965 129.248 47.4146C129.248 46.8327 128.776 46.361 128.194 46.361C127.612 46.361 127.141 46.8327 127.141 47.4146C127.141 47.9965 127.612 48.4683 128.194 48.4683Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8056 51.9805C16.3875 51.9805 16.8593 51.5087 16.8593 50.9268C16.8593 50.3449 16.3875 49.8732 15.8056 49.8732C15.2237 49.8732 14.752 50.3449 14.752 50.9268C14.752 51.5087 15.2237 51.9805 15.8056 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 51.9805C26.9227 51.9805 27.3944 51.5087 27.3944 50.9268C27.3944 50.3449 26.9227 49.8732 26.3408 49.8732C25.7588 49.8732 25.2871 50.3449 25.2871 50.9268C25.2871 51.5087 25.7588 51.9805 26.3408 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8544 51.9805C30.4364 51.9805 30.9081 51.5087 30.9081 50.9268C30.9081 50.3449 30.4364 49.8732 29.8544 49.8732C29.2725 49.8732 28.8008 50.3449 28.8008 50.9268C28.8008 51.5087 29.2725 51.9805 29.8544 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 51.9805C40.9715 51.9805 41.4433 51.5087 41.4433 50.9268C41.4433 50.3449 40.9715 49.8732 40.3896 49.8732C39.8077 49.8732 39.3359 50.3449 39.3359 50.9268C39.3359 51.5087 39.8077 51.9805 40.3896 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 51.9805C51.5086 51.9805 51.9804 51.5087 51.9804 50.9268C51.9804 50.3449 51.5086 49.8732 50.9267 49.8732C50.3448 49.8732 49.873 50.3449 49.873 50.9268C49.873 51.5087 50.3448 51.9805 50.9267 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 51.9805C55.0203 51.9805 55.4921 51.5087 55.4921 50.9268C55.4921 50.3449 55.0203 49.8732 54.4384 49.8732C53.8565 49.8732 53.3848 50.3449 53.3848 50.9268C53.3848 51.5087 53.8565 51.9805 54.4384 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 51.9805C69.0692 51.9805 69.5409 51.5087 69.5409 50.9268C69.5409 50.3449 69.0692 49.8732 68.4873 49.8732C67.9053 49.8732 67.4336 50.3449 67.4336 50.9268C67.4336 51.5087 67.9053 51.9805 68.4873 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 51.9805C79.6063 51.9805 80.078 51.5087 80.078 50.9268C80.078 50.3449 79.6063 49.8732 79.0244 49.8732C78.4424 49.8732 77.9707 50.3449 77.9707 50.9268C77.9707 51.5087 78.4424 51.9805 79.0244 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 51.9805C86.6317 51.9805 87.1034 51.5087 87.1034 50.9268C87.1034 50.3449 86.6317 49.8732 86.0498 49.8732C85.4678 49.8732 84.9961 50.3449 84.9961 50.9268C84.9961 51.5087 85.4678 51.9805 86.0498 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 51.9805C90.1434 51.9805 90.6151 51.5087 90.6151 50.9268C90.6151 50.3449 90.1434 49.8732 89.5615 49.8732C88.9796 49.8732 88.5078 50.3449 88.5078 50.9268C88.5078 51.5087 88.9796 51.9805 89.5615 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 51.9805C97.1668 51.9805 97.6386 51.5087 97.6386 50.9268C97.6386 50.3449 97.1668 49.8732 96.5849 49.8732C96.003 49.8732 95.5312 50.3449 95.5312 50.9268C95.5312 51.5087 96.003 51.9805 96.5849 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 51.9805C100.679 51.9805 101.15 51.5087 101.15 50.9268C101.15 50.3449 100.679 49.8732 100.097 49.8732C99.5147 49.8732 99.043 50.3449 99.043 50.9268C99.043 51.5087 99.5147 51.9805 100.097 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 51.9805C104.192 51.9805 104.664 51.5087 104.664 50.9268C104.664 50.3449 104.192 49.8732 103.61 49.8732C103.028 49.8732 102.557 50.3449 102.557 50.9268C102.557 51.5087 103.028 51.9805 103.61 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 51.9805C107.704 51.9805 108.176 51.5087 108.176 50.9268C108.176 50.3449 107.704 49.8732 107.122 49.8732C106.54 49.8732 106.068 50.3449 106.068 50.9268C106.068 51.5087 106.54 51.9805 107.122 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 51.9805C111.216 51.9805 111.687 51.5087 111.687 50.9268C111.687 50.3449 111.216 49.8732 110.634 49.8732C110.052 49.8732 109.58 50.3449 109.58 50.9268C109.58 51.5087 110.052 51.9805 110.634 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 51.9805C114.727 51.9805 115.199 51.5087 115.199 50.9268C115.199 50.3449 114.727 49.8732 114.145 49.8732C113.564 49.8732 113.092 50.3449 113.092 50.9268C113.092 51.5087 113.564 51.9805 114.145 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 51.9805C121.753 51.9805 122.225 51.5087 122.225 50.9268C122.225 50.3449 121.753 49.8732 121.171 49.8732C120.589 49.8732 120.117 50.3449 120.117 50.9268C120.117 51.5087 120.589 51.9805 121.171 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 51.9805C125.264 51.9805 125.736 51.5087 125.736 50.9268C125.736 50.3449 125.264 49.8732 124.683 49.8732C124.101 49.8732 123.629 50.3449 123.629 50.9268C123.629 51.5087 124.101 51.9805 124.683 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 51.9805C128.776 51.9805 129.248 51.5087 129.248 50.9268C129.248 50.3449 128.776 49.8732 128.194 49.8732C127.612 49.8732 127.141 50.3449 127.141 50.9268C127.141 51.5087 127.612 51.9805 128.194 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 51.9805C132.29 51.9805 132.762 51.5087 132.762 50.9268C132.762 50.3449 132.29 49.8732 131.708 49.8732C131.126 49.8732 130.654 50.3449 130.654 50.9268C130.654 51.5087 131.126 51.9805 131.708 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 51.9805C135.802 51.9805 136.273 51.5087 136.273 50.9268C136.273 50.3449 135.802 49.8732 135.22 49.8732C134.638 49.8732 134.166 50.3449 134.166 50.9268C134.166 51.5087 134.638 51.9805 135.22 51.9805Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78022 55.4927C9.36214 55.4927 9.83388 55.021 9.83388 54.439C9.83388 53.8571 9.36214 53.3854 8.78022 53.3854C8.1983 53.3854 7.72656 53.8571 7.72656 54.439C7.72656 55.021 8.1983 55.4927 8.78022 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2919 55.4927C12.8739 55.4927 13.3456 55.021 13.3456 54.439C13.3456 53.8571 12.8739 53.3854 12.2919 53.3854C11.71 53.3854 11.2383 53.8571 11.2383 54.439C11.2383 55.021 11.71 55.4927 12.2919 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8056 55.4927C16.3875 55.4927 16.8593 55.021 16.8593 54.439C16.8593 53.8571 16.3875 53.3854 15.8056 53.3854C15.2237 53.3854 14.752 53.8571 14.752 54.439C14.752 55.021 15.2237 55.4927 15.8056 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 55.4927C26.9227 55.4927 27.3944 55.021 27.3944 54.439C27.3944 53.8571 26.9227 53.3854 26.3408 53.3854C25.7588 53.3854 25.2871 53.8571 25.2871 54.439C25.2871 55.021 25.7588 55.4927 26.3408 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 55.4927C33.9481 55.4927 34.4198 55.021 34.4198 54.439C34.4198 53.8571 33.9481 53.3854 33.3662 53.3854C32.7842 53.3854 32.3125 53.8571 32.3125 54.439C32.3125 55.021 32.7842 55.4927 33.3662 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 55.4927C44.4852 55.4927 44.9569 55.021 44.9569 54.439C44.9569 53.8571 44.4852 53.3854 43.9033 53.3854C43.3213 53.3854 42.8496 53.8571 42.8496 54.439C42.8496 55.021 43.3213 55.4927 43.9033 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 55.4927C51.5086 55.4927 51.9804 55.021 51.9804 54.439C51.9804 53.8571 51.5086 53.3854 50.9267 53.3854C50.3448 53.3854 49.873 53.8571 49.873 54.439C49.873 55.021 50.3448 55.4927 50.9267 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 55.4927C62.0457 55.4927 62.5175 55.021 62.5175 54.439C62.5175 53.8571 62.0457 53.3854 61.4638 53.3854C60.8819 53.3854 60.4102 53.8571 60.4102 54.439C60.4102 55.021 60.8819 55.4927 61.4638 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 55.4927C65.5575 55.4927 66.0292 55.021 66.0292 54.439C66.0292 53.8571 65.5575 53.3854 64.9755 53.3854C64.3936 53.3854 63.9219 53.8571 63.9219 54.439C63.9219 55.021 64.3936 55.4927 64.9755 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 55.4927C76.0946 55.4927 76.5663 55.021 76.5663 54.439C76.5663 53.8571 76.0946 53.3854 75.5126 53.3854C74.9307 53.3854 74.459 53.8571 74.459 54.439C74.459 55.021 74.9307 55.4927 75.5126 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 55.4927C93.6551 55.4927 94.1268 55.021 94.1268 54.439C94.1268 53.8571 93.6551 53.3854 93.0732 53.3854C92.4913 53.3854 92.0195 53.8571 92.0195 54.439C92.0195 55.021 92.4913 55.4927 93.0732 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 55.4927C97.1668 55.4927 97.6386 55.021 97.6386 54.439C97.6386 53.8571 97.1668 53.3854 96.5849 53.3854C96.003 53.3854 95.5312 53.8571 95.5312 54.439C95.5312 55.021 96.003 55.4927 96.5849 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 55.4927C100.679 55.4927 101.15 55.021 101.15 54.439C101.15 53.8571 100.679 53.3854 100.097 53.3854C99.5147 53.3854 99.043 53.8571 99.043 54.439C99.043 55.021 99.5147 55.4927 100.097 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 55.4927C104.192 55.4927 104.664 55.021 104.664 54.439C104.664 53.8571 104.192 53.3854 103.61 53.3854C103.028 53.3854 102.557 53.8571 102.557 54.439C102.557 55.021 103.028 55.4927 103.61 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 55.4927C107.704 55.4927 108.176 55.021 108.176 54.439C108.176 53.8571 107.704 53.3854 107.122 53.3854C106.54 53.3854 106.068 53.8571 106.068 54.439C106.068 55.021 106.54 55.4927 107.122 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 55.4927C114.727 55.4927 115.199 55.021 115.199 54.439C115.199 53.8571 114.727 53.3854 114.145 53.3854C113.564 53.3854 113.092 53.8571 113.092 54.439C113.092 55.021 113.564 55.4927 114.145 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 55.4927C118.241 55.4927 118.713 55.021 118.713 54.439C118.713 53.8571 118.241 53.3854 117.659 53.3854C117.077 53.3854 116.605 53.8571 116.605 54.439C116.605 55.021 117.077 55.4927 117.659 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 55.4927C121.753 55.4927 122.225 55.021 122.225 54.439C122.225 53.8571 121.753 53.3854 121.171 53.3854C120.589 53.3854 120.117 53.8571 120.117 54.439C120.117 55.021 120.589 55.4927 121.171 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 55.4927C125.264 55.4927 125.736 55.021 125.736 54.439C125.736 53.8571 125.264 53.3854 124.683 53.3854C124.101 53.3854 123.629 53.8571 123.629 54.439C123.629 55.021 124.101 55.4927 124.683 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 55.4927C132.29 55.4927 132.762 55.021 132.762 54.439C132.762 53.8571 132.29 53.3854 131.708 53.3854C131.126 53.3854 130.654 53.8571 130.654 54.439C130.654 55.021 131.126 55.4927 131.708 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 55.4927C135.802 55.4927 136.273 55.021 136.273 54.439C136.273 53.8571 135.802 53.3854 135.22 53.3854C134.638 53.3854 134.166 53.8571 134.166 54.439C134.166 55.021 134.638 55.4927 135.22 55.4927Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78022 59.0049C9.36214 59.0049 9.83388 58.5331 9.83388 57.9512C9.83388 57.3693 9.36214 56.8976 8.78022 56.8976C8.1983 56.8976 7.72656 57.3693 7.72656 57.9512C7.72656 58.5331 8.1983 59.0049 8.78022 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 59.0049C26.9227 59.0049 27.3944 58.5331 27.3944 57.9512C27.3944 57.3693 26.9227 56.8976 26.3408 56.8976C25.7588 56.8976 25.2871 57.3693 25.2871 57.9512C25.2871 58.5331 25.7588 59.0049 26.3408 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8544 59.0049C30.4364 59.0049 30.9081 58.5331 30.9081 57.9512C30.9081 57.3693 30.4364 56.8976 29.8544 56.8976C29.2725 56.8976 28.8008 57.3693 28.8008 57.9512C28.8008 58.5331 29.2725 59.0049 29.8544 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 59.0049C33.9481 59.0049 34.4198 58.5331 34.4198 57.9512C34.4198 57.3693 33.9481 56.8976 33.3662 56.8976C32.7842 56.8976 32.3125 57.3693 32.3125 57.9512C32.3125 58.5331 32.7842 59.0049 33.3662 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 59.0049C40.9715 59.0049 41.4433 58.5331 41.4433 57.9512C41.4433 57.3693 40.9715 56.8976 40.3896 56.8976C39.8077 56.8976 39.3359 57.3693 39.3359 57.9512C39.3359 58.5331 39.8077 59.0049 40.3896 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 59.0049C44.4852 59.0049 44.9569 58.5331 44.9569 57.9512C44.9569 57.3693 44.4852 56.8976 43.9033 56.8976C43.3213 56.8976 42.8496 57.3693 42.8496 57.9512C42.8496 58.5331 43.3213 59.0049 43.9033 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 59.0049C55.0203 59.0049 55.4921 58.5331 55.4921 57.9512C55.4921 57.3693 55.0203 56.8976 54.4384 56.8976C53.8565 56.8976 53.3848 57.3693 53.3848 57.9512C53.3848 58.5331 53.8565 59.0049 54.4384 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 59.0049C58.534 59.0049 59.0058 58.5331 59.0058 57.9512C59.0058 57.3693 58.534 56.8976 57.9521 56.8976C57.3702 56.8976 56.8984 57.3693 56.8984 57.9512C56.8984 58.5331 57.3702 59.0049 57.9521 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 59.0049C65.5575 59.0049 66.0292 58.5331 66.0292 57.9512C66.0292 57.3693 65.5575 56.8976 64.9755 56.8976C64.3936 56.8976 63.9219 57.3693 63.9219 57.9512C63.9219 58.5331 64.3936 59.0049 64.9755 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 59.0049C69.0692 59.0049 69.5409 58.5331 69.5409 57.9512C69.5409 57.3693 69.0692 56.8976 68.4873 56.8976C67.9053 56.8976 67.4336 57.3693 67.4336 57.9512C67.4336 58.5331 67.9053 59.0049 68.4873 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 59.0049C72.5828 59.0049 73.0546 58.5331 73.0546 57.9512C73.0546 57.3693 72.5828 56.8976 72.0009 56.8976C71.419 56.8976 70.9473 57.3693 70.9473 57.9512C70.9473 58.5331 71.419 59.0049 72.0009 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 59.0049C76.0946 59.0049 76.5663 58.5331 76.5663 57.9512C76.5663 57.3693 76.0946 56.8976 75.5126 56.8976C74.9307 56.8976 74.459 57.3693 74.459 57.9512C74.459 58.5331 74.9307 59.0049 75.5126 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 59.0049C79.6063 59.0049 80.078 58.5331 80.078 57.9512C80.078 57.3693 79.6063 56.8976 79.0244 56.8976C78.4424 56.8976 77.9707 57.3693 77.9707 57.9512C77.9707 58.5331 78.4424 59.0049 79.0244 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 59.0049C86.6317 59.0049 87.1034 58.5331 87.1034 57.9512C87.1034 57.3693 86.6317 56.8976 86.0498 56.8976C85.4678 56.8976 84.9961 57.3693 84.9961 57.9512C84.9961 58.5331 85.4678 59.0049 86.0498 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 59.0049C93.6551 59.0049 94.1268 58.5331 94.1268 57.9512C94.1268 57.3693 93.6551 56.8976 93.0732 56.8976C92.4913 56.8976 92.0195 57.3693 92.0195 57.9512C92.0195 58.5331 92.4913 59.0049 93.0732 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 59.0049C97.1668 59.0049 97.6386 58.5331 97.6386 57.9512C97.6386 57.3693 97.1668 56.8976 96.5849 56.8976C96.003 56.8976 95.5312 57.3693 95.5312 57.9512C95.5312 58.5331 96.003 59.0049 96.5849 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 59.0049C100.679 59.0049 101.15 58.5331 101.15 57.9512C101.15 57.3693 100.679 56.8976 100.097 56.8976C99.5147 56.8976 99.043 57.3693 99.043 57.9512C99.043 58.5331 99.5147 59.0049 100.097 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 59.0049C111.216 59.0049 111.687 58.5331 111.687 57.9512C111.687 57.3693 111.216 56.8976 110.634 56.8976C110.052 56.8976 109.58 57.3693 109.58 57.9512C109.58 58.5331 110.052 59.0049 110.634 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 59.0049C121.753 59.0049 122.225 58.5331 122.225 57.9512C122.225 57.3693 121.753 56.8976 121.171 56.8976C120.589 56.8976 120.117 57.3693 120.117 57.9512C120.117 58.5331 120.589 59.0049 121.171 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 59.0049C128.776 59.0049 129.248 58.5331 129.248 57.9512C129.248 57.3693 128.776 56.8976 128.194 56.8976C127.612 56.8976 127.141 57.3693 127.141 57.9512C127.141 58.5331 127.612 59.0049 128.194 59.0049Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.829 62.5171C23.411 62.5171 23.8827 62.0453 23.8827 61.4634C23.8827 60.8815 23.411 60.4098 22.829 60.4098C22.2471 60.4098 21.7754 60.8815 21.7754 61.4634C21.7754 62.0453 22.2471 62.5171 22.829 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 62.5171C26.9227 62.5171 27.3944 62.0453 27.3944 61.4634C27.3944 60.8815 26.9227 60.4098 26.3408 60.4098C25.7588 60.4098 25.2871 60.8815 25.2871 61.4634C25.2871 62.0453 25.7588 62.5171 26.3408 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 62.5171C33.9481 62.5171 34.4198 62.0453 34.4198 61.4634C34.4198 60.8815 33.9481 60.4098 33.3662 60.4098C32.7842 60.4098 32.3125 60.8815 32.3125 61.4634C32.3125 62.0453 32.7842 62.5171 33.3662 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 62.5171C62.0457 62.5171 62.5175 62.0453 62.5175 61.4634C62.5175 60.8815 62.0457 60.4098 61.4638 60.4098C60.8819 60.4098 60.4102 60.8815 60.4102 61.4634C60.4102 62.0453 60.8819 62.5171 61.4638 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 62.5171C69.0692 62.5171 69.5409 62.0453 69.5409 61.4634C69.5409 60.8815 69.0692 60.4098 68.4873 60.4098C67.9053 60.4098 67.4336 60.8815 67.4336 61.4634C67.4336 62.0453 67.9053 62.5171 68.4873 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 62.5171C72.5828 62.5171 73.0546 62.0453 73.0546 61.4634C73.0546 60.8815 72.5828 60.4098 72.0009 60.4098C71.419 60.4098 70.9473 60.8815 70.9473 61.4634C70.9473 62.0453 71.419 62.5171 72.0009 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 62.5171C83.118 62.5171 83.5897 62.0453 83.5897 61.4634C83.5897 60.8815 83.118 60.4098 82.5361 60.4098C81.9542 60.4098 81.4824 60.8815 81.4824 61.4634C81.4824 62.0453 81.9542 62.5171 82.5361 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 62.5171C90.1434 62.5171 90.6151 62.0453 90.6151 61.4634C90.6151 60.8815 90.1434 60.4098 89.5615 60.4098C88.9796 60.4098 88.5078 60.8815 88.5078 61.4634C88.5078 62.0453 88.9796 62.5171 89.5615 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 62.5171C104.192 62.5171 104.664 62.0453 104.664 61.4634C104.664 60.8815 104.192 60.4098 103.61 60.4098C103.028 60.4098 102.557 60.8815 102.557 61.4634C102.557 62.0453 103.028 62.5171 103.61 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 62.5171C111.216 62.5171 111.687 62.0453 111.687 61.4634C111.687 60.8815 111.216 60.4098 110.634 60.4098C110.052 60.4098 109.58 60.8815 109.58 61.4634C109.58 62.0453 110.052 62.5171 110.634 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 62.5171C118.241 62.5171 118.713 62.0453 118.713 61.4634C118.713 60.8815 118.241 60.4098 117.659 60.4098C117.077 60.4098 116.605 60.8815 116.605 61.4634C116.605 62.0453 117.077 62.5171 117.659 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 62.5171C121.753 62.5171 122.225 62.0453 122.225 61.4634C122.225 60.8815 121.753 60.4098 121.171 60.4098C120.589 60.4098 120.117 60.8815 120.117 61.4634C120.117 62.0453 120.589 62.5171 121.171 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 62.5171C132.29 62.5171 132.762 62.0453 132.762 61.4634C132.762 60.8815 132.29 60.4098 131.708 60.4098C131.126 60.4098 130.654 60.8815 130.654 61.4634C130.654 62.0453 131.126 62.5171 131.708 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 62.5171C135.802 62.5171 136.273 62.0453 136.273 61.4634C136.273 60.8815 135.802 60.4098 135.22 60.4098C134.638 60.4098 134.166 60.8815 134.166 61.4634C134.166 62.0453 134.638 62.5171 135.22 62.5171Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78022 66.0293C9.36214 66.0293 9.83388 65.5575 9.83388 64.9756C9.83388 64.3937 9.36214 63.9219 8.78022 63.9219C8.1983 63.9219 7.72656 64.3937 7.72656 64.9756C7.72656 65.5575 8.1983 66.0293 8.78022 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3173 66.0293C19.8992 66.0293 20.371 65.5575 20.371 64.9756C20.371 64.3937 19.8992 63.9219 19.3173 63.9219C18.7354 63.9219 18.2637 64.3937 18.2637 64.9756C18.2637 65.5575 18.7354 66.0293 19.3173 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 66.0293C26.9227 66.0293 27.3944 65.5575 27.3944 64.9756C27.3944 64.3937 26.9227 63.9219 26.3408 63.9219C25.7588 63.9219 25.2871 64.3937 25.2871 64.9756C25.2871 65.5575 25.7588 66.0293 26.3408 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8544 66.0293C30.4364 66.0293 30.9081 65.5575 30.9081 64.9756C30.9081 64.3937 30.4364 63.9219 29.8544 63.9219C29.2725 63.9219 28.8008 64.3937 28.8008 64.9756C28.8008 65.5575 29.2725 66.0293 29.8544 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 66.0293C33.9481 66.0293 34.4198 65.5575 34.4198 64.9756C34.4198 64.3937 33.9481 63.9219 33.3662 63.9219C32.7842 63.9219 32.3125 64.3937 32.3125 64.9756C32.3125 65.5575 32.7842 66.0293 33.3662 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 66.0293C40.9715 66.0293 41.4433 65.5575 41.4433 64.9756C41.4433 64.3937 40.9715 63.9219 40.3896 63.9219C39.8077 63.9219 39.3359 64.3937 39.3359 64.9756C39.3359 65.5575 39.8077 66.0293 40.3896 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 66.0293C51.5086 66.0293 51.9804 65.5575 51.9804 64.9756C51.9804 64.3937 51.5086 63.9219 50.9267 63.9219C50.3448 63.9219 49.873 64.3937 49.873 64.9756C49.873 65.5575 50.3448 66.0293 50.9267 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 66.0293C55.0203 66.0293 55.4921 65.5575 55.4921 64.9756C55.4921 64.3937 55.0203 63.9219 54.4384 63.9219C53.8565 63.9219 53.3848 64.3937 53.3848 64.9756C53.3848 65.5575 53.8565 66.0293 54.4384 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 66.0293C58.534 66.0293 59.0058 65.5575 59.0058 64.9756C59.0058 64.3937 58.534 63.9219 57.9521 63.9219C57.3702 63.9219 56.8984 64.3937 56.8984 64.9756C56.8984 65.5575 57.3702 66.0293 57.9521 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 66.0293C62.0457 66.0293 62.5175 65.5575 62.5175 64.9756C62.5175 64.3937 62.0457 63.9219 61.4638 63.9219C60.8819 63.9219 60.4102 64.3937 60.4102 64.9756C60.4102 65.5575 60.8819 66.0293 61.4638 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 66.0293C65.5575 66.0293 66.0292 65.5575 66.0292 64.9756C66.0292 64.3937 65.5575 63.9219 64.9755 63.9219C64.3936 63.9219 63.9219 64.3937 63.9219 64.9756C63.9219 65.5575 64.3936 66.0293 64.9755 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 66.0293C69.0692 66.0293 69.5409 65.5575 69.5409 64.9756C69.5409 64.3937 69.0692 63.9219 68.4873 63.9219C67.9053 63.9219 67.4336 64.3937 67.4336 64.9756C67.4336 65.5575 67.9053 66.0293 68.4873 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 66.0293C72.5828 66.0293 73.0546 65.5575 73.0546 64.9756C73.0546 64.3937 72.5828 63.9219 72.0009 63.9219C71.419 63.9219 70.9473 64.3937 70.9473 64.9756C70.9473 65.5575 71.419 66.0293 72.0009 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 66.0293C76.0946 66.0293 76.5663 65.5575 76.5663 64.9756C76.5663 64.3937 76.0946 63.9219 75.5126 63.9219C74.9307 63.9219 74.459 64.3937 74.459 64.9756C74.459 65.5575 74.9307 66.0293 75.5126 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 66.0293C79.6063 66.0293 80.078 65.5575 80.078 64.9756C80.078 64.3937 79.6063 63.9219 79.0244 63.9219C78.4424 63.9219 77.9707 64.3937 77.9707 64.9756C77.9707 65.5575 78.4424 66.0293 79.0244 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 66.0293C83.118 66.0293 83.5897 65.5575 83.5897 64.9756C83.5897 64.3937 83.118 63.9219 82.5361 63.9219C81.9542 63.9219 81.4824 64.3937 81.4824 64.9756C81.4824 65.5575 81.9542 66.0293 82.5361 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 66.0293C86.6317 66.0293 87.1034 65.5575 87.1034 64.9756C87.1034 64.3937 86.6317 63.9219 86.0498 63.9219C85.4678 63.9219 84.9961 64.3937 84.9961 64.9756C84.9961 65.5575 85.4678 66.0293 86.0498 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 66.0293C97.1668 66.0293 97.6386 65.5575 97.6386 64.9756C97.6386 64.3937 97.1668 63.9219 96.5849 63.9219C96.003 63.9219 95.5312 64.3937 95.5312 64.9756C95.5312 65.5575 96.003 66.0293 96.5849 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 66.0293C107.704 66.0293 108.176 65.5575 108.176 64.9756C108.176 64.3937 107.704 63.9219 107.122 63.9219C106.54 63.9219 106.068 64.3937 106.068 64.9756C106.068 65.5575 106.54 66.0293 107.122 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 66.0293C111.216 66.0293 111.687 65.5575 111.687 64.9756C111.687 64.3937 111.216 63.9219 110.634 63.9219C110.052 63.9219 109.58 64.3937 109.58 64.9756C109.58 65.5575 110.052 66.0293 110.634 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 66.0293C118.241 66.0293 118.713 65.5575 118.713 64.9756C118.713 64.3937 118.241 63.9219 117.659 63.9219C117.077 63.9219 116.605 64.3937 116.605 64.9756C116.605 65.5575 117.077 66.0293 117.659 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 66.0293C125.264 66.0293 125.736 65.5575 125.736 64.9756C125.736 64.3937 125.264 63.9219 124.683 63.9219C124.101 63.9219 123.629 64.3937 123.629 64.9756C123.629 65.5575 124.101 66.0293 124.683 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 66.0293C128.776 66.0293 129.248 65.5575 129.248 64.9756C129.248 64.3937 128.776 63.9219 128.194 63.9219C127.612 63.9219 127.141 64.3937 127.141 64.9756C127.141 65.5575 127.612 66.0293 128.194 66.0293Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2919 69.5415C12.8739 69.5415 13.3456 69.0698 13.3456 68.4878C13.3456 67.9059 12.8739 67.4342 12.2919 67.4342C11.71 67.4342 11.2383 67.9059 11.2383 68.4878C11.2383 69.0698 11.71 69.5415 12.2919 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.829 69.5415C23.411 69.5415 23.8827 69.0698 23.8827 68.4878C23.8827 67.9059 23.411 67.4342 22.829 67.4342C22.2471 67.4342 21.7754 67.9059 21.7754 68.4878C21.7754 69.0698 22.2471 69.5415 22.829 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 69.5415C33.9481 69.5415 34.4198 69.0698 34.4198 68.4878C34.4198 67.9059 33.9481 67.4342 33.3662 67.4342C32.7842 67.4342 32.3125 67.9059 32.3125 68.4878C32.3125 69.0698 32.7842 69.5415 33.3662 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 69.5415C47.9969 69.5415 48.4686 69.0698 48.4686 68.4878C48.4686 67.9059 47.9969 67.4342 47.415 67.4342C46.8331 67.4342 46.3613 67.9059 46.3613 68.4878C46.3613 69.0698 46.8331 69.5415 47.415 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 69.5415C55.0203 69.5415 55.4921 69.0698 55.4921 68.4878C55.4921 67.9059 55.0203 67.4342 54.4384 67.4342C53.8565 67.4342 53.3848 67.9059 53.3848 68.4878C53.3848 69.0698 53.8565 69.5415 54.4384 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 69.5415C65.5575 69.5415 66.0292 69.0698 66.0292 68.4878C66.0292 67.9059 65.5575 67.4342 64.9755 67.4342C64.3936 67.4342 63.9219 67.9059 63.9219 68.4878C63.9219 69.0698 64.3936 69.5415 64.9755 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 69.5415C76.0946 69.5415 76.5663 69.0698 76.5663 68.4878C76.5663 67.9059 76.0946 67.4342 75.5126 67.4342C74.9307 67.4342 74.459 67.9059 74.459 68.4878C74.459 69.0698 74.9307 69.5415 75.5126 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 69.5415C79.6063 69.5415 80.078 69.0698 80.078 68.4878C80.078 67.9059 79.6063 67.4342 79.0244 67.4342C78.4424 67.4342 77.9707 67.9059 77.9707 68.4878C77.9707 69.0698 78.4424 69.5415 79.0244 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 69.5415C86.6317 69.5415 87.1034 69.0698 87.1034 68.4878C87.1034 67.9059 86.6317 67.4342 86.0498 67.4342C85.4678 67.4342 84.9961 67.9059 84.9961 68.4878C84.9961 69.0698 85.4678 69.5415 86.0498 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 69.5415C90.1434 69.5415 90.6151 69.0698 90.6151 68.4878C90.6151 67.9059 90.1434 67.4342 89.5615 67.4342C88.9796 67.4342 88.5078 67.9059 88.5078 68.4878C88.5078 69.0698 88.9796 69.5415 89.5615 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 69.5415C93.6551 69.5415 94.1268 69.0698 94.1268 68.4878C94.1268 67.9059 93.6551 67.4342 93.0732 67.4342C92.4913 67.4342 92.0195 67.9059 92.0195 68.4878C92.0195 69.0698 92.4913 69.5415 93.0732 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 69.5415C97.1668 69.5415 97.6386 69.0698 97.6386 68.4878C97.6386 67.9059 97.1668 67.4342 96.5849 67.4342C96.003 67.4342 95.5312 67.9059 95.5312 68.4878C95.5312 69.0698 96.003 69.5415 96.5849 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 69.5415C104.192 69.5415 104.664 69.0698 104.664 68.4878C104.664 67.9059 104.192 67.4342 103.61 67.4342C103.028 67.4342 102.557 67.9059 102.557 68.4878C102.557 69.0698 103.028 69.5415 103.61 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 69.5415C107.704 69.5415 108.176 69.0698 108.176 68.4878C108.176 67.9059 107.704 67.4342 107.122 67.4342C106.54 67.4342 106.068 67.9059 106.068 68.4878C106.068 69.0698 106.54 69.5415 107.122 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 69.5415C111.216 69.5415 111.687 69.0698 111.687 68.4878C111.687 67.9059 111.216 67.4342 110.634 67.4342C110.052 67.4342 109.58 67.9059 109.58 68.4878C109.58 69.0698 110.052 69.5415 110.634 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 69.5415C114.727 69.5415 115.199 69.0698 115.199 68.4878C115.199 67.9059 114.727 67.4342 114.145 67.4342C113.564 67.4342 113.092 67.9059 113.092 68.4878C113.092 69.0698 113.564 69.5415 114.145 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 69.5415C118.241 69.5415 118.713 69.0698 118.713 68.4878C118.713 67.9059 118.241 67.4342 117.659 67.4342C117.077 67.4342 116.605 67.9059 116.605 68.4878C116.605 69.0698 117.077 69.5415 117.659 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 69.5415C132.29 69.5415 132.762 69.0698 132.762 68.4878C132.762 67.9059 132.29 67.4342 131.708 67.4342C131.126 67.4342 130.654 67.9059 130.654 68.4878C130.654 69.0698 131.126 69.5415 131.708 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 69.5415C135.802 69.5415 136.273 69.0698 136.273 68.4878C136.273 67.9059 135.802 67.4342 135.22 67.4342C134.638 67.4342 134.166 67.9059 134.166 68.4878C134.166 69.0698 134.638 69.5415 135.22 69.5415Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3173 73.0537C19.8992 73.0537 20.371 72.582 20.371 72C20.371 71.4181 19.8992 70.9464 19.3173 70.9464C18.7354 70.9464 18.2637 71.4181 18.2637 72C18.2637 72.582 18.7354 73.0537 19.3173 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.829 73.0537C23.411 73.0537 23.8827 72.582 23.8827 72C23.8827 71.4181 23.411 70.9464 22.829 70.9464C22.2471 70.9464 21.7754 71.4181 21.7754 72C21.7754 72.582 22.2471 73.0537 22.829 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8544 73.0537C30.4364 73.0537 30.9081 72.582 30.9081 72C30.9081 71.4181 30.4364 70.9464 29.8544 70.9464C29.2725 70.9464 28.8008 71.4181 28.8008 72C28.8008 72.582 29.2725 73.0537 29.8544 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 73.0537C40.9715 73.0537 41.4433 72.582 41.4433 72C41.4433 71.4181 40.9715 70.9464 40.3896 70.9464C39.8077 70.9464 39.3359 71.4181 39.3359 72C39.3359 72.582 39.8077 73.0537 40.3896 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 73.0537C44.4852 73.0537 44.9569 72.582 44.9569 72C44.9569 71.4181 44.4852 70.9464 43.9033 70.9464C43.3213 70.9464 42.8496 71.4181 42.8496 72C42.8496 72.582 43.3213 73.0537 43.9033 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 73.0537C55.0203 73.0537 55.4921 72.582 55.4921 72C55.4921 71.4181 55.0203 70.9464 54.4384 70.9464C53.8565 70.9464 53.3848 71.4181 53.3848 72C53.3848 72.582 53.8565 73.0537 54.4384 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 73.0537C58.534 73.0537 59.0058 72.582 59.0058 72C59.0058 71.4181 58.534 70.9464 57.9521 70.9464C57.3702 70.9464 56.8984 71.4181 56.8984 72C56.8984 72.582 57.3702 73.0537 57.9521 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 73.0537C62.0457 73.0537 62.5175 72.582 62.5175 72C62.5175 71.4181 62.0457 70.9464 61.4638 70.9464C60.8819 70.9464 60.4102 71.4181 60.4102 72C60.4102 72.582 60.8819 73.0537 61.4638 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 73.0537C65.5575 73.0537 66.0292 72.582 66.0292 72C66.0292 71.4181 65.5575 70.9464 64.9755 70.9464C64.3936 70.9464 63.9219 71.4181 63.9219 72C63.9219 72.582 64.3936 73.0537 64.9755 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 73.0537C72.5828 73.0537 73.0546 72.582 73.0546 72C73.0546 71.4181 72.5828 70.9464 72.0009 70.9464C71.419 70.9464 70.9473 71.4181 70.9473 72C70.9473 72.582 71.419 73.0537 72.0009 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 73.0537C76.0946 73.0537 76.5663 72.582 76.5663 72C76.5663 71.4181 76.0946 70.9464 75.5126 70.9464C74.9307 70.9464 74.459 71.4181 74.459 72C74.459 72.582 74.9307 73.0537 75.5126 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 73.0537C83.118 73.0537 83.5897 72.582 83.5897 72C83.5897 71.4181 83.118 70.9464 82.5361 70.9464C81.9542 70.9464 81.4824 71.4181 81.4824 72C81.4824 72.582 81.9542 73.0537 82.5361 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 73.0537C93.6551 73.0537 94.1268 72.582 94.1268 72C94.1268 71.4181 93.6551 70.9464 93.0732 70.9464C92.4913 70.9464 92.0195 71.4181 92.0195 72C92.0195 72.582 92.4913 73.0537 93.0732 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 73.0537C100.679 73.0537 101.15 72.582 101.15 72C101.15 71.4181 100.679 70.9464 100.097 70.9464C99.5147 70.9464 99.043 71.4181 99.043 72C99.043 72.582 99.5147 73.0537 100.097 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 73.0537C104.192 73.0537 104.664 72.582 104.664 72C104.664 71.4181 104.192 70.9464 103.61 70.9464C103.028 70.9464 102.557 71.4181 102.557 72C102.557 72.582 103.028 73.0537 103.61 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 73.0537C114.727 73.0537 115.199 72.582 115.199 72C115.199 71.4181 114.727 70.9464 114.145 70.9464C113.564 70.9464 113.092 71.4181 113.092 72C113.092 72.582 113.564 73.0537 114.145 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 73.0537C132.29 73.0537 132.762 72.582 132.762 72C132.762 71.4181 132.29 70.9464 131.708 70.9464C131.126 70.9464 130.654 71.4181 130.654 72C130.654 72.582 131.126 73.0537 131.708 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 73.0537C135.802 73.0537 136.273 72.582 136.273 72C136.273 71.4181 135.802 70.9464 135.22 70.9464C134.638 70.9464 134.166 71.4181 134.166 72C134.166 72.582 134.638 73.0537 135.22 73.0537Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78022 76.5659C9.36214 76.5659 9.83388 76.0941 9.83388 75.5122C9.83388 74.9303 9.36214 74.4586 8.78022 74.4586C8.1983 74.4586 7.72656 74.9303 7.72656 75.5122C7.72656 76.0941 8.1983 76.5659 8.78022 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 76.5659C26.9227 76.5659 27.3944 76.0941 27.3944 75.5122C27.3944 74.9303 26.9227 74.4586 26.3408 74.4586C25.7588 74.4586 25.2871 74.9303 25.2871 75.5122C25.2871 76.0941 25.7588 76.5659 26.3408 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 76.5659C33.9481 76.5659 34.4198 76.0941 34.4198 75.5122C34.4198 74.9303 33.9481 74.4586 33.3662 74.4586C32.7842 74.4586 32.3125 74.9303 32.3125 75.5122C32.3125 76.0941 32.7842 76.5659 33.3662 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 76.5659C37.4598 76.5659 37.9315 76.0941 37.9315 75.5122C37.9315 74.9303 37.4598 74.4586 36.8779 74.4586C36.296 74.4586 35.8242 74.9303 35.8242 75.5122C35.8242 76.0941 36.296 76.5659 36.8779 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 76.5659C44.4852 76.5659 44.9569 76.0941 44.9569 75.5122C44.9569 74.9303 44.4852 74.4586 43.9033 74.4586C43.3213 74.4586 42.8496 74.9303 42.8496 75.5122C42.8496 76.0941 43.3213 76.5659 43.9033 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 76.5659C47.9969 76.5659 48.4686 76.0941 48.4686 75.5122C48.4686 74.9303 47.9969 74.4586 47.415 74.4586C46.8331 74.4586 46.3613 74.9303 46.3613 75.5122C46.3613 76.0941 46.8331 76.5659 47.415 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 76.5659C55.0203 76.5659 55.4921 76.0941 55.4921 75.5122C55.4921 74.9303 55.0203 74.4586 54.4384 74.4586C53.8565 74.4586 53.3848 74.9303 53.3848 75.5122C53.3848 76.0941 53.8565 76.5659 54.4384 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 76.5659C69.0692 76.5659 69.5409 76.0941 69.5409 75.5122C69.5409 74.9303 69.0692 74.4586 68.4873 74.4586C67.9053 74.4586 67.4336 74.9303 67.4336 75.5122C67.4336 76.0941 67.9053 76.5659 68.4873 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 76.5659C72.5828 76.5659 73.0546 76.0941 73.0546 75.5122C73.0546 74.9303 72.5828 74.4586 72.0009 74.4586C71.419 74.4586 70.9473 74.9303 70.9473 75.5122C70.9473 76.0941 71.419 76.5659 72.0009 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 76.5659C76.0946 76.5659 76.5663 76.0941 76.5663 75.5122C76.5663 74.9303 76.0946 74.4586 75.5126 74.4586C74.9307 74.4586 74.459 74.9303 74.459 75.5122C74.459 76.0941 74.9307 76.5659 75.5126 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 76.5659C86.6317 76.5659 87.1034 76.0941 87.1034 75.5122C87.1034 74.9303 86.6317 74.4586 86.0498 74.4586C85.4678 74.4586 84.9961 74.9303 84.9961 75.5122C84.9961 76.0941 85.4678 76.5659 86.0498 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 76.5659C107.704 76.5659 108.176 76.0941 108.176 75.5122C108.176 74.9303 107.704 74.4586 107.122 74.4586C106.54 74.4586 106.068 74.9303 106.068 75.5122C106.068 76.0941 106.54 76.5659 107.122 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 76.5659C111.216 76.5659 111.687 76.0941 111.687 75.5122C111.687 74.9303 111.216 74.4586 110.634 74.4586C110.052 74.4586 109.58 74.9303 109.58 75.5122C109.58 76.0941 110.052 76.5659 110.634 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 76.5659C118.241 76.5659 118.713 76.0941 118.713 75.5122C118.713 74.9303 118.241 74.4586 117.659 74.4586C117.077 74.4586 116.605 74.9303 116.605 75.5122C116.605 76.0941 117.077 76.5659 117.659 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 76.5659C121.753 76.5659 122.225 76.0941 122.225 75.5122C122.225 74.9303 121.753 74.4586 121.171 74.4586C120.589 74.4586 120.117 74.9303 120.117 75.5122C120.117 76.0941 120.589 76.5659 121.171 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 76.5659C125.264 76.5659 125.736 76.0941 125.736 75.5122C125.736 74.9303 125.264 74.4586 124.683 74.4586C124.101 74.4586 123.629 74.9303 123.629 75.5122C123.629 76.0941 124.101 76.5659 124.683 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 76.5659C132.29 76.5659 132.762 76.0941 132.762 75.5122C132.762 74.9303 132.29 74.4586 131.708 74.4586C131.126 74.4586 130.654 74.9303 130.654 75.5122C130.654 76.0941 131.126 76.5659 131.708 76.5659Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78022 80.0781C9.36214 80.0781 9.83388 79.6063 9.83388 79.0244C9.83388 78.4425 9.36214 77.9708 8.78022 77.9708C8.1983 77.9708 7.72656 78.4425 7.72656 79.0244C7.72656 79.6063 8.1983 80.0781 8.78022 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2919 80.0781C12.8739 80.0781 13.3456 79.6063 13.3456 79.0244C13.3456 78.4425 12.8739 77.9708 12.2919 77.9708C11.71 77.9708 11.2383 78.4425 11.2383 79.0244C11.2383 79.6063 11.71 80.0781 12.2919 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3173 80.0781C19.8992 80.0781 20.371 79.6063 20.371 79.0244C20.371 78.4425 19.8992 77.9708 19.3173 77.9708C18.7354 77.9708 18.2637 78.4425 18.2637 79.0244C18.2637 79.6063 18.7354 80.0781 19.3173 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.829 80.0781C23.411 80.0781 23.8827 79.6063 23.8827 79.0244C23.8827 78.4425 23.411 77.9708 22.829 77.9708C22.2471 77.9708 21.7754 78.4425 21.7754 79.0244C21.7754 79.6063 22.2471 80.0781 22.829 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8544 80.0781C30.4364 80.0781 30.9081 79.6063 30.9081 79.0244C30.9081 78.4425 30.4364 77.9708 29.8544 77.9708C29.2725 77.9708 28.8008 78.4425 28.8008 79.0244C28.8008 79.6063 29.2725 80.0781 29.8544 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 80.0781C33.9481 80.0781 34.4198 79.6063 34.4198 79.0244C34.4198 78.4425 33.9481 77.9708 33.3662 77.9708C32.7842 77.9708 32.3125 78.4425 32.3125 79.0244C32.3125 79.6063 32.7842 80.0781 33.3662 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 80.0781C37.4598 80.0781 37.9315 79.6063 37.9315 79.0244C37.9315 78.4425 37.4598 77.9708 36.8779 77.9708C36.296 77.9708 35.8242 78.4425 35.8242 79.0244C35.8242 79.6063 36.296 80.0781 36.8779 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 80.0781C58.534 80.0781 59.0058 79.6063 59.0058 79.0244C59.0058 78.4425 58.534 77.9708 57.9521 77.9708C57.3702 77.9708 56.8984 78.4425 56.8984 79.0244C56.8984 79.6063 57.3702 80.0781 57.9521 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 80.0781C65.5575 80.0781 66.0292 79.6063 66.0292 79.0244C66.0292 78.4425 65.5575 77.9708 64.9755 77.9708C64.3936 77.9708 63.9219 78.4425 63.9219 79.0244C63.9219 79.6063 64.3936 80.0781 64.9755 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 80.0781C69.0692 80.0781 69.5409 79.6063 69.5409 79.0244C69.5409 78.4425 69.0692 77.9708 68.4873 77.9708C67.9053 77.9708 67.4336 78.4425 67.4336 79.0244C67.4336 79.6063 67.9053 80.0781 68.4873 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 80.0781C72.5828 80.0781 73.0546 79.6063 73.0546 79.0244C73.0546 78.4425 72.5828 77.9708 72.0009 77.9708C71.419 77.9708 70.9473 78.4425 70.9473 79.0244C70.9473 79.6063 71.419 80.0781 72.0009 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 80.0781C83.118 80.0781 83.5897 79.6063 83.5897 79.0244C83.5897 78.4425 83.118 77.9708 82.5361 77.9708C81.9542 77.9708 81.4824 78.4425 81.4824 79.0244C81.4824 79.6063 81.9542 80.0781 82.5361 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 80.0781C107.704 80.0781 108.176 79.6063 108.176 79.0244C108.176 78.4425 107.704 77.9708 107.122 77.9708C106.54 77.9708 106.068 78.4425 106.068 79.0244C106.068 79.6063 106.54 80.0781 107.122 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 80.0781C111.216 80.0781 111.687 79.6063 111.687 79.0244C111.687 78.4425 111.216 77.9708 110.634 77.9708C110.052 77.9708 109.58 78.4425 109.58 79.0244C109.58 79.6063 110.052 80.0781 110.634 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 80.0781C118.241 80.0781 118.713 79.6063 118.713 79.0244C118.713 78.4425 118.241 77.9708 117.659 77.9708C117.077 77.9708 116.605 78.4425 116.605 79.0244C116.605 79.6063 117.077 80.0781 117.659 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 80.0781C121.753 80.0781 122.225 79.6063 122.225 79.0244C122.225 78.4425 121.753 77.9708 121.171 77.9708C120.589 77.9708 120.117 78.4425 120.117 79.0244C120.117 79.6063 120.589 80.0781 121.171 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 80.0781C135.802 80.0781 136.273 79.6063 136.273 79.0244C136.273 78.4425 135.802 77.9708 135.22 77.9708C134.638 77.9708 134.166 78.4425 134.166 79.0244C134.166 79.6063 134.638 80.0781 135.22 80.0781Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2919 83.5903C12.8739 83.5903 13.3456 83.1185 13.3456 82.5366C13.3456 81.9547 12.8739 81.4829 12.2919 81.4829C11.71 81.4829 11.2383 81.9547 11.2383 82.5366C11.2383 83.1185 11.71 83.5903 12.2919 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 83.5903C33.9481 83.5903 34.4198 83.1185 34.4198 82.5366C34.4198 81.9547 33.9481 81.4829 33.3662 81.4829C32.7842 81.4829 32.3125 81.9547 32.3125 82.5366C32.3125 83.1185 32.7842 83.5903 33.3662 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 83.5903C44.4852 83.5903 44.9569 83.1185 44.9569 82.5366C44.9569 81.9547 44.4852 81.4829 43.9033 81.4829C43.3213 81.4829 42.8496 81.9547 42.8496 82.5366C42.8496 83.1185 43.3213 83.5903 43.9033 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 83.5903C47.9969 83.5903 48.4686 83.1185 48.4686 82.5366C48.4686 81.9547 47.9969 81.4829 47.415 81.4829C46.8331 81.4829 46.3613 81.9547 46.3613 82.5366C46.3613 83.1185 46.8331 83.5903 47.415 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 83.5903C58.534 83.5903 59.0058 83.1185 59.0058 82.5366C59.0058 81.9547 58.534 81.4829 57.9521 81.4829C57.3702 81.4829 56.8984 81.9547 56.8984 82.5366C56.8984 83.1185 57.3702 83.5903 57.9521 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 83.5903C65.5575 83.5903 66.0292 83.1185 66.0292 82.5366C66.0292 81.9547 65.5575 81.4829 64.9755 81.4829C64.3936 81.4829 63.9219 81.9547 63.9219 82.5366C63.9219 83.1185 64.3936 83.5903 64.9755 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 83.5903C76.0946 83.5903 76.5663 83.1185 76.5663 82.5366C76.5663 81.9547 76.0946 81.4829 75.5126 81.4829C74.9307 81.4829 74.459 81.9547 74.459 82.5366C74.459 83.1185 74.9307 83.5903 75.5126 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 83.5903C79.6063 83.5903 80.078 83.1185 80.078 82.5366C80.078 81.9547 79.6063 81.4829 79.0244 81.4829C78.4424 81.4829 77.9707 81.9547 77.9707 82.5366C77.9707 83.1185 78.4424 83.5903 79.0244 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 83.5903C86.6317 83.5903 87.1034 83.1185 87.1034 82.5366C87.1034 81.9547 86.6317 81.4829 86.0498 81.4829C85.4678 81.4829 84.9961 81.9547 84.9961 82.5366C84.9961 83.1185 85.4678 83.5903 86.0498 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 83.5903C90.1434 83.5903 90.6151 83.1185 90.6151 82.5366C90.6151 81.9547 90.1434 81.4829 89.5615 81.4829C88.9796 81.4829 88.5078 81.9547 88.5078 82.5366C88.5078 83.1185 88.9796 83.5903 89.5615 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 83.5903C93.6551 83.5903 94.1268 83.1185 94.1268 82.5366C94.1268 81.9547 93.6551 81.4829 93.0732 81.4829C92.4913 81.4829 92.0195 81.9547 92.0195 82.5366C92.0195 83.1185 92.4913 83.5903 93.0732 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 83.5903C107.704 83.5903 108.176 83.1185 108.176 82.5366C108.176 81.9547 107.704 81.4829 107.122 81.4829C106.54 81.4829 106.068 81.9547 106.068 82.5366C106.068 83.1185 106.54 83.5903 107.122 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 83.5903C111.216 83.5903 111.687 83.1185 111.687 82.5366C111.687 81.9547 111.216 81.4829 110.634 81.4829C110.052 81.4829 109.58 81.9547 109.58 82.5366C109.58 83.1185 110.052 83.5903 110.634 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 83.5903C125.264 83.5903 125.736 83.1185 125.736 82.5366C125.736 81.9547 125.264 81.4829 124.683 81.4829C124.101 81.4829 123.629 81.9547 123.629 82.5366C123.629 83.1185 124.101 83.5903 124.683 83.5903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78022 87.1025C9.36214 87.1025 9.83388 86.6307 9.83388 86.0488C9.83388 85.4669 9.36214 84.9951 8.78022 84.9951C8.1983 84.9951 7.72656 85.4669 7.72656 86.0488C7.72656 86.6307 8.1983 87.1025 8.78022 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2919 87.1025C12.8739 87.1025 13.3456 86.6307 13.3456 86.0488C13.3456 85.4669 12.8739 84.9951 12.2919 84.9951C11.71 84.9951 11.2383 85.4669 11.2383 86.0488C11.2383 86.6307 11.71 87.1025 12.2919 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8056 87.1025C16.3875 87.1025 16.8593 86.6307 16.8593 86.0488C16.8593 85.4669 16.3875 84.9951 15.8056 84.9951C15.2237 84.9951 14.752 85.4669 14.752 86.0488C14.752 86.6307 15.2237 87.1025 15.8056 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8544 87.1025C30.4364 87.1025 30.9081 86.6307 30.9081 86.0488C30.9081 85.4669 30.4364 84.9951 29.8544 84.9951C29.2725 84.9951 28.8008 85.4669 28.8008 86.0488C28.8008 86.6307 29.2725 87.1025 29.8544 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 87.1025C33.9481 87.1025 34.4198 86.6307 34.4198 86.0488C34.4198 85.4669 33.9481 84.9951 33.3662 84.9951C32.7842 84.9951 32.3125 85.4669 32.3125 86.0488C32.3125 86.6307 32.7842 87.1025 33.3662 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 87.1025C37.4598 87.1025 37.9315 86.6307 37.9315 86.0488C37.9315 85.4669 37.4598 84.9951 36.8779 84.9951C36.296 84.9951 35.8242 85.4669 35.8242 86.0488C35.8242 86.6307 36.296 87.1025 36.8779 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 87.1025C40.9715 87.1025 41.4433 86.6307 41.4433 86.0488C41.4433 85.4669 40.9715 84.9951 40.3896 84.9951C39.8077 84.9951 39.3359 85.4669 39.3359 86.0488C39.3359 86.6307 39.8077 87.1025 40.3896 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 87.1025C44.4852 87.1025 44.9569 86.6307 44.9569 86.0488C44.9569 85.4669 44.4852 84.9951 43.9033 84.9951C43.3213 84.9951 42.8496 85.4669 42.8496 86.0488C42.8496 86.6307 43.3213 87.1025 43.9033 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 87.1025C47.9969 87.1025 48.4686 86.6307 48.4686 86.0488C48.4686 85.4669 47.9969 84.9951 47.415 84.9951C46.8331 84.9951 46.3613 85.4669 46.3613 86.0488C46.3613 86.6307 46.8331 87.1025 47.415 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 87.1025C51.5086 87.1025 51.9804 86.6307 51.9804 86.0488C51.9804 85.4669 51.5086 84.9951 50.9267 84.9951C50.3448 84.9951 49.873 85.4669 49.873 86.0488C49.873 86.6307 50.3448 87.1025 50.9267 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 87.1025C55.0203 87.1025 55.4921 86.6307 55.4921 86.0488C55.4921 85.4669 55.0203 84.9951 54.4384 84.9951C53.8565 84.9951 53.3848 85.4669 53.3848 86.0488C53.3848 86.6307 53.8565 87.1025 54.4384 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 87.1025C65.5575 87.1025 66.0292 86.6307 66.0292 86.0488C66.0292 85.4669 65.5575 84.9951 64.9755 84.9951C64.3936 84.9951 63.9219 85.4669 63.9219 86.0488C63.9219 86.6307 64.3936 87.1025 64.9755 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 87.1025C69.0692 87.1025 69.5409 86.6307 69.5409 86.0488C69.5409 85.4669 69.0692 84.9951 68.4873 84.9951C67.9053 84.9951 67.4336 85.4669 67.4336 86.0488C67.4336 86.6307 67.9053 87.1025 68.4873 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 87.1025C79.6063 87.1025 80.078 86.6307 80.078 86.0488C80.078 85.4669 79.6063 84.9951 79.0244 84.9951C78.4424 84.9951 77.9707 85.4669 77.9707 86.0488C77.9707 86.6307 78.4424 87.1025 79.0244 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 87.1025C90.1434 87.1025 90.6151 86.6307 90.6151 86.0488C90.6151 85.4669 90.1434 84.9951 89.5615 84.9951C88.9796 84.9951 88.5078 85.4669 88.5078 86.0488C88.5078 86.6307 88.9796 87.1025 89.5615 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 87.1025C93.6551 87.1025 94.1268 86.6307 94.1268 86.0488C94.1268 85.4669 93.6551 84.9951 93.0732 84.9951C92.4913 84.9951 92.0195 85.4669 92.0195 86.0488C92.0195 86.6307 92.4913 87.1025 93.0732 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 87.1025C100.679 87.1025 101.15 86.6307 101.15 86.0488C101.15 85.4669 100.679 84.9951 100.097 84.9951C99.5147 84.9951 99.043 85.4669 99.043 86.0488C99.043 86.6307 99.5147 87.1025 100.097 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 87.1025C118.241 87.1025 118.713 86.6307 118.713 86.0488C118.713 85.4669 118.241 84.9951 117.659 84.9951C117.077 84.9951 116.605 85.4669 116.605 86.0488C116.605 86.6307 117.077 87.1025 117.659 87.1025Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78022 90.6147C9.36214 90.6147 9.83388 90.1429 9.83388 89.561C9.83388 88.9791 9.36214 88.5074 8.78022 88.5074C8.1983 88.5074 7.72656 88.9791 7.72656 89.561C7.72656 90.1429 8.1983 90.6147 8.78022 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2919 90.6147C12.8739 90.6147 13.3456 90.1429 13.3456 89.561C13.3456 88.9791 12.8739 88.5074 12.2919 88.5074C11.71 88.5074 11.2383 88.9791 11.2383 89.561C11.2383 90.1429 11.71 90.6147 12.2919 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3173 90.6147C19.8992 90.6147 20.371 90.1429 20.371 89.561C20.371 88.9791 19.8992 88.5074 19.3173 88.5074C18.7354 88.5074 18.2637 88.9791 18.2637 89.561C18.2637 90.1429 18.7354 90.6147 19.3173 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.829 90.6147C23.411 90.6147 23.8827 90.1429 23.8827 89.561C23.8827 88.9791 23.411 88.5074 22.829 88.5074C22.2471 88.5074 21.7754 88.9791 21.7754 89.561C21.7754 90.1429 22.2471 90.6147 22.829 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 90.6147C44.4852 90.6147 44.9569 90.1429 44.9569 89.561C44.9569 88.9791 44.4852 88.5074 43.9033 88.5074C43.3213 88.5074 42.8496 88.9791 42.8496 89.561C42.8496 90.1429 43.3213 90.6147 43.9033 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 90.6147C58.534 90.6147 59.0058 90.1429 59.0058 89.561C59.0058 88.9791 58.534 88.5074 57.9521 88.5074C57.3702 88.5074 56.8984 88.9791 56.8984 89.561C56.8984 90.1429 57.3702 90.6147 57.9521 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 90.6147C72.5828 90.6147 73.0546 90.1429 73.0546 89.561C73.0546 88.9791 72.5828 88.5074 72.0009 88.5074C71.419 88.5074 70.9473 88.9791 70.9473 89.561C70.9473 90.1429 71.419 90.6147 72.0009 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 90.6147C86.6317 90.6147 87.1034 90.1429 87.1034 89.561C87.1034 88.9791 86.6317 88.5074 86.0498 88.5074C85.4678 88.5074 84.9961 88.9791 84.9961 89.561C84.9961 90.1429 85.4678 90.6147 86.0498 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 90.6147C93.6551 90.6147 94.1268 90.1429 94.1268 89.561C94.1268 88.9791 93.6551 88.5074 93.0732 88.5074C92.4913 88.5074 92.0195 88.9791 92.0195 89.561C92.0195 90.1429 92.4913 90.6147 93.0732 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 90.6147C97.1668 90.6147 97.6386 90.1429 97.6386 89.561C97.6386 88.9791 97.1668 88.5074 96.5849 88.5074C96.003 88.5074 95.5312 88.9791 95.5312 89.561C95.5312 90.1429 96.003 90.6147 96.5849 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 90.6147C100.679 90.6147 101.15 90.1429 101.15 89.561C101.15 88.9791 100.679 88.5074 100.097 88.5074C99.5147 88.5074 99.043 88.9791 99.043 89.561C99.043 90.1429 99.5147 90.6147 100.097 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 90.6147C104.192 90.6147 104.664 90.1429 104.664 89.561C104.664 88.9791 104.192 88.5074 103.61 88.5074C103.028 88.5074 102.557 88.9791 102.557 89.561C102.557 90.1429 103.028 90.6147 103.61 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 90.6147C111.216 90.6147 111.687 90.1429 111.687 89.561C111.687 88.9791 111.216 88.5074 110.634 88.5074C110.052 88.5074 109.58 88.9791 109.58 89.561C109.58 90.1429 110.052 90.6147 110.634 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 90.6147C114.727 90.6147 115.199 90.1429 115.199 89.561C115.199 88.9791 114.727 88.5074 114.145 88.5074C113.564 88.5074 113.092 88.9791 113.092 89.561C113.092 90.1429 113.564 90.6147 114.145 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 90.6147C121.753 90.6147 122.225 90.1429 122.225 89.561C122.225 88.9791 121.753 88.5074 121.171 88.5074C120.589 88.5074 120.117 88.9791 120.117 89.561C120.117 90.1429 120.589 90.6147 121.171 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 90.6147C125.264 90.6147 125.736 90.1429 125.736 89.561C125.736 88.9791 125.264 88.5074 124.683 88.5074C124.101 88.5074 123.629 88.9791 123.629 89.561C123.629 90.1429 124.101 90.6147 124.683 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 90.6147C128.776 90.6147 129.248 90.1429 129.248 89.561C129.248 88.9791 128.776 88.5074 128.194 88.5074C127.612 88.5074 127.141 88.9791 127.141 89.561C127.141 90.1429 127.612 90.6147 128.194 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 90.6147C132.29 90.6147 132.762 90.1429 132.762 89.561C132.762 88.9791 132.29 88.5074 131.708 88.5074C131.126 88.5074 130.654 88.9791 130.654 89.561C130.654 90.1429 131.126 90.6147 131.708 90.6147Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78022 94.1268C9.36214 94.1268 9.83388 93.6551 9.83388 93.0732C9.83388 92.4913 9.36214 92.0195 8.78022 92.0195C8.1983 92.0195 7.72656 92.4913 7.72656 93.0732C7.72656 93.6551 8.1983 94.1268 8.78022 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2919 94.1268C12.8739 94.1268 13.3456 93.6551 13.3456 93.0732C13.3456 92.4913 12.8739 92.0195 12.2919 92.0195C11.71 92.0195 11.2383 92.4913 11.2383 93.0732C11.2383 93.6551 11.71 94.1268 12.2919 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8056 94.1268C16.3875 94.1268 16.8593 93.6551 16.8593 93.0732C16.8593 92.4913 16.3875 92.0195 15.8056 92.0195C15.2237 92.0195 14.752 92.4913 14.752 93.0732C14.752 93.6551 15.2237 94.1268 15.8056 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.829 94.1268C23.411 94.1268 23.8827 93.6551 23.8827 93.0732C23.8827 92.4913 23.411 92.0195 22.829 92.0195C22.2471 92.0195 21.7754 92.4913 21.7754 93.0732C21.7754 93.6551 22.2471 94.1268 22.829 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 94.1268C26.9227 94.1268 27.3944 93.6551 27.3944 93.0732C27.3944 92.4913 26.9227 92.0195 26.3408 92.0195C25.7588 92.0195 25.2871 92.4913 25.2871 93.0732C25.2871 93.6551 25.7588 94.1268 26.3408 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8544 94.1268C30.4364 94.1268 30.9081 93.6551 30.9081 93.0732C30.9081 92.4913 30.4364 92.0195 29.8544 92.0195C29.2725 92.0195 28.8008 92.4913 28.8008 93.0732C28.8008 93.6551 29.2725 94.1268 29.8544 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 94.1268C40.9715 94.1268 41.4433 93.6551 41.4433 93.0732C41.4433 92.4913 40.9715 92.0195 40.3896 92.0195C39.8077 92.0195 39.3359 92.4913 39.3359 93.0732C39.3359 93.6551 39.8077 94.1268 40.3896 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 94.1268C44.4852 94.1268 44.9569 93.6551 44.9569 93.0732C44.9569 92.4913 44.4852 92.0195 43.9033 92.0195C43.3213 92.0195 42.8496 92.4913 42.8496 93.0732C42.8496 93.6551 43.3213 94.1268 43.9033 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 94.1268C72.5828 94.1268 73.0546 93.6551 73.0546 93.0732C73.0546 92.4913 72.5828 92.0195 72.0009 92.0195C71.419 92.0195 70.9473 92.4913 70.9473 93.0732C70.9473 93.6551 71.419 94.1268 72.0009 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 94.1268C86.6317 94.1268 87.1034 93.6551 87.1034 93.0732C87.1034 92.4913 86.6317 92.0195 86.0498 92.0195C85.4678 92.0195 84.9961 92.4913 84.9961 93.0732C84.9961 93.6551 85.4678 94.1268 86.0498 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 94.1268C90.1434 94.1268 90.6151 93.6551 90.6151 93.0732C90.6151 92.4913 90.1434 92.0195 89.5615 92.0195C88.9796 92.0195 88.5078 92.4913 88.5078 93.0732C88.5078 93.6551 88.9796 94.1268 89.5615 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 94.1268C97.1668 94.1268 97.6386 93.6551 97.6386 93.0732C97.6386 92.4913 97.1668 92.0195 96.5849 92.0195C96.003 92.0195 95.5312 92.4913 95.5312 93.0732C95.5312 93.6551 96.003 94.1268 96.5849 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 94.1268C100.679 94.1268 101.15 93.6551 101.15 93.0732C101.15 92.4913 100.679 92.0195 100.097 92.0195C99.5147 92.0195 99.043 92.4913 99.043 93.0732C99.043 93.6551 99.5147 94.1268 100.097 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 94.1268C107.704 94.1268 108.176 93.6551 108.176 93.0732C108.176 92.4913 107.704 92.0195 107.122 92.0195C106.54 92.0195 106.068 92.4913 106.068 93.0732C106.068 93.6551 106.54 94.1268 107.122 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 94.1268C114.727 94.1268 115.199 93.6551 115.199 93.0732C115.199 92.4913 114.727 92.0195 114.145 92.0195C113.564 92.0195 113.092 92.4913 113.092 93.0732C113.092 93.6551 113.564 94.1268 114.145 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 94.1268C118.241 94.1268 118.713 93.6551 118.713 93.0732C118.713 92.4913 118.241 92.0195 117.659 92.0195C117.077 92.0195 116.605 92.4913 116.605 93.0732C116.605 93.6551 117.077 94.1268 117.659 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 94.1268C121.753 94.1268 122.225 93.6551 122.225 93.0732C122.225 92.4913 121.753 92.0195 121.171 92.0195C120.589 92.0195 120.117 92.4913 120.117 93.0732C120.117 93.6551 120.589 94.1268 121.171 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 94.1268C128.776 94.1268 129.248 93.6551 129.248 93.0732C129.248 92.4913 128.776 92.0195 128.194 92.0195C127.612 92.0195 127.141 92.4913 127.141 93.0732C127.141 93.6551 127.612 94.1268 128.194 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 94.1268C132.29 94.1268 132.762 93.6551 132.762 93.0732C132.762 92.4913 132.29 92.0195 131.708 92.0195C131.126 92.0195 130.654 92.4913 130.654 93.0732C130.654 93.6551 131.126 94.1268 131.708 94.1268Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2919 97.6391C12.8739 97.6391 13.3456 97.1673 13.3456 96.5854C13.3456 96.0035 12.8739 95.5317 12.2919 95.5317C11.71 95.5317 11.2383 96.0035 11.2383 96.5854C11.2383 97.1673 11.71 97.6391 12.2919 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.829 97.6391C23.411 97.6391 23.8827 97.1673 23.8827 96.5854C23.8827 96.0035 23.411 95.5317 22.829 95.5317C22.2471 95.5317 21.7754 96.0035 21.7754 96.5854C21.7754 97.1673 22.2471 97.6391 22.829 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 97.6391C26.9227 97.6391 27.3944 97.1673 27.3944 96.5854C27.3944 96.0035 26.9227 95.5317 26.3408 95.5317C25.7588 95.5317 25.2871 96.0035 25.2871 96.5854C25.2871 97.1673 25.7588 97.6391 26.3408 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 97.6391C37.4598 97.6391 37.9315 97.1673 37.9315 96.5854C37.9315 96.0035 37.4598 95.5317 36.8779 95.5317C36.296 95.5317 35.8242 96.0035 35.8242 96.5854C35.8242 97.1673 36.296 97.6391 36.8779 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 97.6391C47.9969 97.6391 48.4686 97.1673 48.4686 96.5854C48.4686 96.0035 47.9969 95.5317 47.415 95.5317C46.8331 95.5317 46.3613 96.0035 46.3613 96.5854C46.3613 97.1673 46.8331 97.6391 47.415 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 97.6391C51.5086 97.6391 51.9804 97.1673 51.9804 96.5854C51.9804 96.0035 51.5086 95.5317 50.9267 95.5317C50.3448 95.5317 49.873 96.0035 49.873 96.5854C49.873 97.1673 50.3448 97.6391 50.9267 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 97.6391C65.5575 97.6391 66.0292 97.1673 66.0292 96.5854C66.0292 96.0035 65.5575 95.5317 64.9755 95.5317C64.3936 95.5317 63.9219 96.0035 63.9219 96.5854C63.9219 97.1673 64.3936 97.6391 64.9755 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 97.6391C69.0692 97.6391 69.5409 97.1673 69.5409 96.5854C69.5409 96.0035 69.0692 95.5317 68.4873 95.5317C67.9053 95.5317 67.4336 96.0035 67.4336 96.5854C67.4336 97.1673 67.9053 97.6391 68.4873 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 97.6391C72.5828 97.6391 73.0546 97.1673 73.0546 96.5854C73.0546 96.0035 72.5828 95.5317 72.0009 95.5317C71.419 95.5317 70.9473 96.0035 70.9473 96.5854C70.9473 97.1673 71.419 97.6391 72.0009 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 97.6391C79.6063 97.6391 80.078 97.1673 80.078 96.5854C80.078 96.0035 79.6063 95.5317 79.0244 95.5317C78.4424 95.5317 77.9707 96.0035 77.9707 96.5854C77.9707 97.1673 78.4424 97.6391 79.0244 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 97.6391C93.6551 97.6391 94.1268 97.1673 94.1268 96.5854C94.1268 96.0035 93.6551 95.5317 93.0732 95.5317C92.4913 95.5317 92.0195 96.0035 92.0195 96.5854C92.0195 97.1673 92.4913 97.6391 93.0732 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 97.6391C97.1668 97.6391 97.6386 97.1673 97.6386 96.5854C97.6386 96.0035 97.1668 95.5317 96.5849 95.5317C96.003 95.5317 95.5312 96.0035 95.5312 96.5854C95.5312 97.1673 96.003 97.6391 96.5849 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 97.6391C104.192 97.6391 104.664 97.1673 104.664 96.5854C104.664 96.0035 104.192 95.5317 103.61 95.5317C103.028 95.5317 102.557 96.0035 102.557 96.5854C102.557 97.1673 103.028 97.6391 103.61 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 97.6391C114.727 97.6391 115.199 97.1673 115.199 96.5854C115.199 96.0035 114.727 95.5317 114.145 95.5317C113.564 95.5317 113.092 96.0035 113.092 96.5854C113.092 97.1673 113.564 97.6391 114.145 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 97.6391C121.753 97.6391 122.225 97.1673 122.225 96.5854C122.225 96.0035 121.753 95.5317 121.171 95.5317C120.589 95.5317 120.117 96.0035 120.117 96.5854C120.117 97.1673 120.589 97.6391 121.171 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 97.6391C125.264 97.6391 125.736 97.1673 125.736 96.5854C125.736 96.0035 125.264 95.5317 124.683 95.5317C124.101 95.5317 123.629 96.0035 123.629 96.5854C123.629 97.1673 124.101 97.6391 124.683 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 97.6391C132.29 97.6391 132.762 97.1673 132.762 96.5854C132.762 96.0035 132.29 95.5317 131.708 95.5317C131.126 95.5317 130.654 96.0035 130.654 96.5854C130.654 97.1673 131.126 97.6391 131.708 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 97.6391C135.802 97.6391 136.273 97.1673 136.273 96.5854C136.273 96.0035 135.802 95.5317 135.22 95.5317C134.638 95.5317 134.166 96.0035 134.166 96.5854C134.166 97.1673 134.638 97.6391 135.22 97.6391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2919 101.151C12.8739 101.151 13.3456 100.679 13.3456 100.098C13.3456 99.5157 12.8739 99.0439 12.2919 99.0439C11.71 99.0439 11.2383 99.5157 11.2383 100.098C11.2383 100.679 11.71 101.151 12.2919 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8056 101.151C16.3875 101.151 16.8593 100.679 16.8593 100.098C16.8593 99.5157 16.3875 99.0439 15.8056 99.0439C15.2237 99.0439 14.752 99.5157 14.752 100.098C14.752 100.679 15.2237 101.151 15.8056 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3173 101.151C19.8992 101.151 20.371 100.679 20.371 100.098C20.371 99.5157 19.8992 99.0439 19.3173 99.0439C18.7354 99.0439 18.2637 99.5157 18.2637 100.098C18.2637 100.679 18.7354 101.151 19.3173 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8544 101.151C30.4364 101.151 30.9081 100.679 30.9081 100.098C30.9081 99.5157 30.4364 99.0439 29.8544 99.0439C29.2725 99.0439 28.8008 99.5157 28.8008 100.098C28.8008 100.679 29.2725 101.151 29.8544 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3662 101.151C33.9481 101.151 34.4198 100.679 34.4198 100.098C34.4198 99.5157 33.9481 99.0439 33.3662 99.0439C32.7842 99.0439 32.3125 99.5157 32.3125 100.098C32.3125 100.679 32.7842 101.151 33.3662 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 101.151C37.4598 101.151 37.9315 100.679 37.9315 100.098C37.9315 99.5157 37.4598 99.0439 36.8779 99.0439C36.296 99.0439 35.8242 99.5157 35.8242 100.098C35.8242 100.679 36.296 101.151 36.8779 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 101.151C40.9715 101.151 41.4433 100.679 41.4433 100.098C41.4433 99.5157 40.9715 99.0439 40.3896 99.0439C39.8077 99.0439 39.3359 99.5157 39.3359 100.098C39.3359 100.679 39.8077 101.151 40.3896 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 101.151C47.9969 101.151 48.4686 100.679 48.4686 100.098C48.4686 99.5157 47.9969 99.0439 47.415 99.0439C46.8331 99.0439 46.3613 99.5157 46.3613 100.098C46.3613 100.679 46.8331 101.151 47.415 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 101.151C58.534 101.151 59.0058 100.679 59.0058 100.098C59.0058 99.5157 58.534 99.0439 57.9521 99.0439C57.3702 99.0439 56.8984 99.5157 56.8984 100.098C56.8984 100.679 57.3702 101.151 57.9521 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 101.151C62.0457 101.151 62.5175 100.679 62.5175 100.098C62.5175 99.5157 62.0457 99.0439 61.4638 99.0439C60.8819 99.0439 60.4102 99.5157 60.4102 100.098C60.4102 100.679 60.8819 101.151 61.4638 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 101.151C65.5575 101.151 66.0292 100.679 66.0292 100.098C66.0292 99.5157 65.5575 99.0439 64.9755 99.0439C64.3936 99.0439 63.9219 99.5157 63.9219 100.098C63.9219 100.679 64.3936 101.151 64.9755 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 101.151C72.5828 101.151 73.0546 100.679 73.0546 100.098C73.0546 99.5157 72.5828 99.0439 72.0009 99.0439C71.419 99.0439 70.9473 99.5157 70.9473 100.098C70.9473 100.679 71.419 101.151 72.0009 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 101.151C76.0946 101.151 76.5663 100.679 76.5663 100.098C76.5663 99.5157 76.0946 99.0439 75.5126 99.0439C74.9307 99.0439 74.459 99.5157 74.459 100.098C74.459 100.679 74.9307 101.151 75.5126 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 101.151C79.6063 101.151 80.078 100.679 80.078 100.098C80.078 99.5157 79.6063 99.0439 79.0244 99.0439C78.4424 99.0439 77.9707 99.5157 77.9707 100.098C77.9707 100.679 78.4424 101.151 79.0244 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 101.151C86.6317 101.151 87.1034 100.679 87.1034 100.098C87.1034 99.5157 86.6317 99.0439 86.0498 99.0439C85.4678 99.0439 84.9961 99.5157 84.9961 100.098C84.9961 100.679 85.4678 101.151 86.0498 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 101.151C93.6551 101.151 94.1268 100.679 94.1268 100.098C94.1268 99.5157 93.6551 99.0439 93.0732 99.0439C92.4913 99.0439 92.0195 99.5157 92.0195 100.098C92.0195 100.679 92.4913 101.151 93.0732 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 101.151C100.679 101.151 101.15 100.679 101.15 100.098C101.15 99.5157 100.679 99.0439 100.097 99.0439C99.5147 99.0439 99.043 99.5157 99.043 100.098C99.043 100.679 99.5147 101.151 100.097 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 101.151C118.241 101.151 118.713 100.679 118.713 100.098C118.713 99.5157 118.241 99.0439 117.659 99.0439C117.077 99.0439 116.605 99.5157 116.605 100.098C116.605 100.679 117.077 101.151 117.659 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 101.151C128.776 101.151 129.248 100.679 129.248 100.098C129.248 99.5157 128.776 99.0439 128.194 99.0439C127.612 99.0439 127.141 99.5157 127.141 100.098C127.141 100.679 127.612 101.151 128.194 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 101.151C132.29 101.151 132.762 100.679 132.762 100.098C132.762 99.5157 132.29 99.0439 131.708 99.0439C131.126 99.0439 130.654 99.5157 130.654 100.098C130.654 100.679 131.126 101.151 131.708 101.151Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.78022 104.663C9.36214 104.663 9.83388 104.192 9.83388 103.61C9.83388 103.028 9.36214 102.556 8.78022 102.556C8.1983 102.556 7.72656 103.028 7.72656 103.61C7.72656 104.192 8.1983 104.663 8.78022 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 104.663C26.9227 104.663 27.3944 104.192 27.3944 103.61C27.3944 103.028 26.9227 102.556 26.3408 102.556C25.7588 102.556 25.2871 103.028 25.2871 103.61C25.2871 104.192 25.7588 104.663 26.3408 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 104.663C40.9715 104.663 41.4433 104.192 41.4433 103.61C41.4433 103.028 40.9715 102.556 40.3896 102.556C39.8077 102.556 39.3359 103.028 39.3359 103.61C39.3359 104.192 39.8077 104.663 40.3896 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 104.663C44.4852 104.663 44.9569 104.192 44.9569 103.61C44.9569 103.028 44.4852 102.556 43.9033 102.556C43.3213 102.556 42.8496 103.028 42.8496 103.61C42.8496 104.192 43.3213 104.663 43.9033 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 104.663C47.9969 104.663 48.4686 104.192 48.4686 103.61C48.4686 103.028 47.9969 102.556 47.415 102.556C46.8331 102.556 46.3613 103.028 46.3613 103.61C46.3613 104.192 46.8331 104.663 47.415 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 104.663C51.5086 104.663 51.9804 104.192 51.9804 103.61C51.9804 103.028 51.5086 102.556 50.9267 102.556C50.3448 102.556 49.873 103.028 49.873 103.61C49.873 104.192 50.3448 104.663 50.9267 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 104.663C65.5575 104.663 66.0292 104.192 66.0292 103.61C66.0292 103.028 65.5575 102.556 64.9755 102.556C64.3936 102.556 63.9219 103.028 63.9219 103.61C63.9219 104.192 64.3936 104.663 64.9755 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 104.663C72.5828 104.663 73.0546 104.192 73.0546 103.61C73.0546 103.028 72.5828 102.556 72.0009 102.556C71.419 102.556 70.9473 103.028 70.9473 103.61C70.9473 104.192 71.419 104.663 72.0009 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 104.663C79.6063 104.663 80.078 104.192 80.078 103.61C80.078 103.028 79.6063 102.556 79.0244 102.556C78.4424 102.556 77.9707 103.028 77.9707 103.61C77.9707 104.192 78.4424 104.663 79.0244 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 104.663C83.118 104.663 83.5897 104.192 83.5897 103.61C83.5897 103.028 83.118 102.556 82.5361 102.556C81.9542 102.556 81.4824 103.028 81.4824 103.61C81.4824 104.192 81.9542 104.663 82.5361 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 104.663C90.1434 104.663 90.6151 104.192 90.6151 103.61C90.6151 103.028 90.1434 102.556 89.5615 102.556C88.9796 102.556 88.5078 103.028 88.5078 103.61C88.5078 104.192 88.9796 104.663 89.5615 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 104.663C104.192 104.663 104.664 104.192 104.664 103.61C104.664 103.028 104.192 102.556 103.61 102.556C103.028 102.556 102.557 103.028 102.557 103.61C102.557 104.192 103.028 104.663 103.61 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 104.663C114.727 104.663 115.199 104.192 115.199 103.61C115.199 103.028 114.727 102.556 114.145 102.556C113.564 102.556 113.092 103.028 113.092 103.61C113.092 104.192 113.564 104.663 114.145 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 104.663C118.241 104.663 118.713 104.192 118.713 103.61C118.713 103.028 118.241 102.556 117.659 102.556C117.077 102.556 116.605 103.028 116.605 103.61C116.605 104.192 117.077 104.663 117.659 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 104.663C125.264 104.663 125.736 104.192 125.736 103.61C125.736 103.028 125.264 102.556 124.683 102.556C124.101 102.556 123.629 103.028 123.629 103.61C123.629 104.192 124.101 104.663 124.683 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 104.663C132.29 104.663 132.762 104.192 132.762 103.61C132.762 103.028 132.29 102.556 131.708 102.556C131.126 102.556 130.654 103.028 130.654 103.61C130.654 104.192 131.126 104.663 131.708 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 104.663C135.802 104.663 136.273 104.192 136.273 103.61C136.273 103.028 135.802 102.556 135.22 102.556C134.638 102.556 134.166 103.028 134.166 103.61C134.166 104.192 134.638 104.663 135.22 104.663Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8056 108.176C16.3875 108.176 16.8593 107.704 16.8593 107.122C16.8593 106.54 16.3875 106.068 15.8056 106.068C15.2237 106.068 14.752 106.54 14.752 107.122C14.752 107.704 15.2237 108.176 15.8056 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.829 108.176C23.411 108.176 23.8827 107.704 23.8827 107.122C23.8827 106.54 23.411 106.068 22.829 106.068C22.2471 106.068 21.7754 106.54 21.7754 107.122C21.7754 107.704 22.2471 108.176 22.829 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3408 108.176C26.9227 108.176 27.3944 107.704 27.3944 107.122C27.3944 106.54 26.9227 106.068 26.3408 106.068C25.7588 106.068 25.2871 106.54 25.2871 107.122C25.2871 107.704 25.7588 108.176 26.3408 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.8544 108.176C30.4364 108.176 30.9081 107.704 30.9081 107.122C30.9081 106.54 30.4364 106.068 29.8544 106.068C29.2725 106.068 28.8008 106.54 28.8008 107.122C28.8008 107.704 29.2725 108.176 29.8544 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 108.176C44.4852 108.176 44.9569 107.704 44.9569 107.122C44.9569 106.54 44.4852 106.068 43.9033 106.068C43.3213 106.068 42.8496 106.54 42.8496 107.122C42.8496 107.704 43.3213 108.176 43.9033 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 108.176C47.9969 108.176 48.4686 107.704 48.4686 107.122C48.4686 106.54 47.9969 106.068 47.415 106.068C46.8331 106.068 46.3613 106.54 46.3613 107.122C46.3613 107.704 46.8331 108.176 47.415 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 108.176C58.534 108.176 59.0058 107.704 59.0058 107.122C59.0058 106.54 58.534 106.068 57.9521 106.068C57.3702 106.068 56.8984 106.54 56.8984 107.122C56.8984 107.704 57.3702 108.176 57.9521 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 108.176C62.0457 108.176 62.5175 107.704 62.5175 107.122C62.5175 106.54 62.0457 106.068 61.4638 106.068C60.8819 106.068 60.4102 106.54 60.4102 107.122C60.4102 107.704 60.8819 108.176 61.4638 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 108.176C72.5828 108.176 73.0546 107.704 73.0546 107.122C73.0546 106.54 72.5828 106.068 72.0009 106.068C71.419 106.068 70.9473 106.54 70.9473 107.122C70.9473 107.704 71.419 108.176 72.0009 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 108.176C79.6063 108.176 80.078 107.704 80.078 107.122C80.078 106.54 79.6063 106.068 79.0244 106.068C78.4424 106.068 77.9707 106.54 77.9707 107.122C77.9707 107.704 78.4424 108.176 79.0244 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 108.176C83.118 108.176 83.5897 107.704 83.5897 107.122C83.5897 106.54 83.118 106.068 82.5361 106.068C81.9542 106.068 81.4824 106.54 81.4824 107.122C81.4824 107.704 81.9542 108.176 82.5361 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 108.176C86.6317 108.176 87.1034 107.704 87.1034 107.122C87.1034 106.54 86.6317 106.068 86.0498 106.068C85.4678 106.068 84.9961 106.54 84.9961 107.122C84.9961 107.704 85.4678 108.176 86.0498 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 108.176C97.1668 108.176 97.6386 107.704 97.6386 107.122C97.6386 106.54 97.1668 106.068 96.5849 106.068C96.003 106.068 95.5312 106.54 95.5312 107.122C95.5312 107.704 96.003 108.176 96.5849 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 108.176C107.704 108.176 108.176 107.704 108.176 107.122C108.176 106.54 107.704 106.068 107.122 106.068C106.54 106.068 106.068 106.54 106.068 107.122C106.068 107.704 106.54 108.176 107.122 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 108.176C111.216 108.176 111.687 107.704 111.687 107.122C111.687 106.54 111.216 106.068 110.634 106.068C110.052 106.068 109.58 106.54 109.58 107.122C109.58 107.704 110.052 108.176 110.634 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 108.176C114.727 108.176 115.199 107.704 115.199 107.122C115.199 106.54 114.727 106.068 114.145 106.068C113.564 106.068 113.092 106.54 113.092 107.122C113.092 107.704 113.564 108.176 114.145 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 108.176C118.241 108.176 118.713 107.704 118.713 107.122C118.713 106.54 118.241 106.068 117.659 106.068C117.077 106.068 116.605 106.54 116.605 107.122C116.605 107.704 117.077 108.176 117.659 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 108.176C121.753 108.176 122.225 107.704 122.225 107.122C122.225 106.54 121.753 106.068 121.171 106.068C120.589 106.068 120.117 106.54 120.117 107.122C120.117 107.704 120.589 108.176 121.171 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 108.176C125.264 108.176 125.736 107.704 125.736 107.122C125.736 106.54 125.264 106.068 124.683 106.068C124.101 106.068 123.629 106.54 123.629 107.122C123.629 107.704 124.101 108.176 124.683 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 108.176C128.776 108.176 129.248 107.704 129.248 107.122C129.248 106.54 128.776 106.068 128.194 106.068C127.612 106.068 127.141 106.54 127.141 107.122C127.141 107.704 127.612 108.176 128.194 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 108.176C132.29 108.176 132.762 107.704 132.762 107.122C132.762 106.54 132.29 106.068 131.708 106.068C131.126 106.068 130.654 106.54 130.654 107.122C130.654 107.704 131.126 108.176 131.708 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 108.176C135.802 108.176 136.273 107.704 136.273 107.122C136.273 106.54 135.802 106.068 135.22 106.068C134.638 106.068 134.166 106.54 134.166 107.122C134.166 107.704 134.638 108.176 135.22 108.176Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 111.688C37.4598 111.688 37.9315 111.216 37.9315 110.634C37.9315 110.052 37.4598 109.581 36.8779 109.581C36.296 109.581 35.8242 110.052 35.8242 110.634C35.8242 111.216 36.296 111.688 36.8779 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 111.688C40.9715 111.688 41.4433 111.216 41.4433 110.634C41.4433 110.052 40.9715 109.581 40.3896 109.581C39.8077 109.581 39.3359 110.052 39.3359 110.634C39.3359 111.216 39.8077 111.688 40.3896 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 111.688C44.4852 111.688 44.9569 111.216 44.9569 110.634C44.9569 110.052 44.4852 109.581 43.9033 109.581C43.3213 109.581 42.8496 110.052 42.8496 110.634C42.8496 111.216 43.3213 111.688 43.9033 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 111.688C55.0203 111.688 55.4921 111.216 55.4921 110.634C55.4921 110.052 55.0203 109.581 54.4384 109.581C53.8565 109.581 53.3848 110.052 53.3848 110.634C53.3848 111.216 53.8565 111.688 54.4384 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 111.688C62.0457 111.688 62.5175 111.216 62.5175 110.634C62.5175 110.052 62.0457 109.581 61.4638 109.581C60.8819 109.581 60.4102 110.052 60.4102 110.634C60.4102 111.216 60.8819 111.688 61.4638 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 111.688C65.5575 111.688 66.0292 111.216 66.0292 110.634C66.0292 110.052 65.5575 109.581 64.9755 109.581C64.3936 109.581 63.9219 110.052 63.9219 110.634C63.9219 111.216 64.3936 111.688 64.9755 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 111.688C69.0692 111.688 69.5409 111.216 69.5409 110.634C69.5409 110.052 69.0692 109.581 68.4873 109.581C67.9053 109.581 67.4336 110.052 67.4336 110.634C67.4336 111.216 67.9053 111.688 68.4873 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 111.688C79.6063 111.688 80.078 111.216 80.078 110.634C80.078 110.052 79.6063 109.581 79.0244 109.581C78.4424 109.581 77.9707 110.052 77.9707 110.634C77.9707 111.216 78.4424 111.688 79.0244 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 111.688C83.118 111.688 83.5897 111.216 83.5897 110.634C83.5897 110.052 83.118 109.581 82.5361 109.581C81.9542 109.581 81.4824 110.052 81.4824 110.634C81.4824 111.216 81.9542 111.688 82.5361 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 111.688C90.1434 111.688 90.6151 111.216 90.6151 110.634C90.6151 110.052 90.1434 109.581 89.5615 109.581C88.9796 109.581 88.5078 110.052 88.5078 110.634C88.5078 111.216 88.9796 111.688 89.5615 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 111.688C93.6551 111.688 94.1268 111.216 94.1268 110.634C94.1268 110.052 93.6551 109.581 93.0732 109.581C92.4913 109.581 92.0195 110.052 92.0195 110.634C92.0195 111.216 92.4913 111.688 93.0732 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 111.688C97.1668 111.688 97.6386 111.216 97.6386 110.634C97.6386 110.052 97.1668 109.581 96.5849 109.581C96.003 109.581 95.5312 110.052 95.5312 110.634C95.5312 111.216 96.003 111.688 96.5849 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 111.688C107.704 111.688 108.176 111.216 108.176 110.634C108.176 110.052 107.704 109.581 107.122 109.581C106.54 109.581 106.068 110.052 106.068 110.634C106.068 111.216 106.54 111.688 107.122 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 111.688C121.753 111.688 122.225 111.216 122.225 110.634C122.225 110.052 121.753 109.581 121.171 109.581C120.589 109.581 120.117 110.052 120.117 110.634C120.117 111.216 120.589 111.688 121.171 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 111.688C128.776 111.688 129.248 111.216 129.248 110.634C129.248 110.052 128.776 109.581 128.194 109.581C127.612 109.581 127.141 110.052 127.141 110.634C127.141 111.216 127.612 111.688 128.194 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 111.688C135.802 111.688 136.273 111.216 136.273 110.634C136.273 110.052 135.802 109.581 135.22 109.581C134.638 109.581 134.166 110.052 134.166 110.634C134.166 111.216 134.638 111.688 135.22 111.688Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 115.2C37.4598 115.2 37.9315 114.728 37.9315 114.146C37.9315 113.564 37.4598 113.093 36.8779 113.093C36.296 113.093 35.8242 113.564 35.8242 114.146C35.8242 114.728 36.296 115.2 36.8779 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 115.2C44.4852 115.2 44.9569 114.728 44.9569 114.146C44.9569 113.564 44.4852 113.093 43.9033 113.093C43.3213 113.093 42.8496 113.564 42.8496 114.146C42.8496 114.728 43.3213 115.2 43.9033 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 115.2C47.9969 115.2 48.4686 114.728 48.4686 114.146C48.4686 113.564 47.9969 113.093 47.415 113.093C46.8331 113.093 46.3613 113.564 46.3613 114.146C46.3613 114.728 46.8331 115.2 47.415 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 115.2C62.0457 115.2 62.5175 114.728 62.5175 114.146C62.5175 113.564 62.0457 113.093 61.4638 113.093C60.8819 113.093 60.4102 113.564 60.4102 114.146C60.4102 114.728 60.8819 115.2 61.4638 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 115.2C69.0692 115.2 69.5409 114.728 69.5409 114.146C69.5409 113.564 69.0692 113.093 68.4873 113.093C67.9053 113.093 67.4336 113.564 67.4336 114.146C67.4336 114.728 67.9053 115.2 68.4873 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 115.2C79.6063 115.2 80.078 114.728 80.078 114.146C80.078 113.564 79.6063 113.093 79.0244 113.093C78.4424 113.093 77.9707 113.564 77.9707 114.146C77.9707 114.728 78.4424 115.2 79.0244 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 115.2C86.6317 115.2 87.1034 114.728 87.1034 114.146C87.1034 113.564 86.6317 113.093 86.0498 113.093C85.4678 113.093 84.9961 113.564 84.9961 114.146C84.9961 114.728 85.4678 115.2 86.0498 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 115.2C100.679 115.2 101.15 114.728 101.15 114.146C101.15 113.564 100.679 113.093 100.097 113.093C99.5147 113.093 99.043 113.564 99.043 114.146C99.043 114.728 99.5147 115.2 100.097 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 115.2C107.704 115.2 108.176 114.728 108.176 114.146C108.176 113.564 107.704 113.093 107.122 113.093C106.54 113.093 106.068 113.564 106.068 114.146C106.068 114.728 106.54 115.2 107.122 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 115.2C114.727 115.2 115.199 114.728 115.199 114.146C115.199 113.564 114.727 113.093 114.145 113.093C113.564 113.093 113.092 113.564 113.092 114.146C113.092 114.728 113.564 115.2 114.145 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 115.2C121.753 115.2 122.225 114.728 122.225 114.146C122.225 113.564 121.753 113.093 121.171 113.093C120.589 113.093 120.117 113.564 120.117 114.146C120.117 114.728 120.589 115.2 121.171 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 115.2C128.776 115.2 129.248 114.728 129.248 114.146C129.248 113.564 128.776 113.093 128.194 113.093C127.612 113.093 127.141 113.564 127.141 114.146C127.141 114.728 127.612 115.2 128.194 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 115.2C132.29 115.2 132.762 114.728 132.762 114.146C132.762 113.564 132.29 113.093 131.708 113.093C131.126 113.093 130.654 113.564 130.654 114.146C130.654 114.728 131.126 115.2 131.708 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 115.2C135.802 115.2 136.273 114.728 136.273 114.146C136.273 113.564 135.802 113.093 135.22 113.093C134.638 113.093 134.166 113.564 134.166 114.146C134.166 114.728 134.638 115.2 135.22 115.2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 118.712C37.4598 118.712 37.9315 118.24 37.9315 117.659C37.9315 117.077 37.4598 116.605 36.8779 116.605C36.296 116.605 35.8242 117.077 35.8242 117.659C35.8242 118.24 36.296 118.712 36.8779 118.712Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 118.712C47.9969 118.712 48.4686 118.24 48.4686 117.659C48.4686 117.077 47.9969 116.605 47.415 116.605C46.8331 116.605 46.3613 117.077 46.3613 117.659C46.3613 118.24 46.8331 118.712 47.415 118.712Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 118.712C51.5086 118.712 51.9804 118.24 51.9804 117.659C51.9804 117.077 51.5086 116.605 50.9267 116.605C50.3448 116.605 49.873 117.077 49.873 117.659C49.873 118.24 50.3448 118.712 50.9267 118.712Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 118.712C58.534 118.712 59.0058 118.24 59.0058 117.659C59.0058 117.077 58.534 116.605 57.9521 116.605C57.3702 116.605 56.8984 117.077 56.8984 117.659C56.8984 118.24 57.3702 118.712 57.9521 118.712Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 118.712C76.0946 118.712 76.5663 118.24 76.5663 117.659C76.5663 117.077 76.0946 116.605 75.5126 116.605C74.9307 116.605 74.459 117.077 74.459 117.659C74.459 118.24 74.9307 118.712 75.5126 118.712Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 118.712C86.6317 118.712 87.1034 118.24 87.1034 117.659C87.1034 117.077 86.6317 116.605 86.0498 116.605C85.4678 116.605 84.9961 117.077 84.9961 117.659C84.9961 118.24 85.4678 118.712 86.0498 118.712Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 118.712C93.6551 118.712 94.1268 118.24 94.1268 117.659C94.1268 117.077 93.6551 116.605 93.0732 116.605C92.4913 116.605 92.0195 117.077 92.0195 117.659C92.0195 118.24 92.4913 118.712 93.0732 118.712Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 118.712C100.679 118.712 101.15 118.24 101.15 117.659C101.15 117.077 100.679 116.605 100.097 116.605C99.5147 116.605 99.043 117.077 99.043 117.659C99.043 118.24 99.5147 118.712 100.097 118.712Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 118.712C107.704 118.712 108.176 118.24 108.176 117.659C108.176 117.077 107.704 116.605 107.122 116.605C106.54 116.605 106.068 117.077 106.068 117.659C106.068 118.24 106.54 118.712 107.122 118.712Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 118.712C121.753 118.712 122.225 118.24 122.225 117.659C122.225 117.077 121.753 116.605 121.171 116.605C120.589 116.605 120.117 117.077 120.117 117.659C120.117 118.24 120.589 118.712 121.171 118.712Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 118.712C135.802 118.712 136.273 118.24 136.273 117.659C136.273 117.077 135.802 116.605 135.22 116.605C134.638 116.605 134.166 117.077 134.166 117.659C134.166 118.24 134.638 118.712 135.22 118.712Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 122.224C40.9715 122.224 41.4433 121.753 41.4433 121.171C41.4433 120.589 40.9715 120.117 40.3896 120.117C39.8077 120.117 39.3359 120.589 39.3359 121.171C39.3359 121.753 39.8077 122.224 40.3896 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.9267 122.224C51.5086 122.224 51.9804 121.753 51.9804 121.171C51.9804 120.589 51.5086 120.117 50.9267 120.117C50.3448 120.117 49.873 120.589 49.873 121.171C49.873 121.753 50.3448 122.224 50.9267 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 122.224C58.534 122.224 59.0058 121.753 59.0058 121.171C59.0058 120.589 58.534 120.117 57.9521 120.117C57.3702 120.117 56.8984 120.589 56.8984 121.171C56.8984 121.753 57.3702 122.224 57.9521 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 122.224C62.0457 122.224 62.5175 121.753 62.5175 121.171C62.5175 120.589 62.0457 120.117 61.4638 120.117C60.8819 120.117 60.4102 120.589 60.4102 121.171C60.4102 121.753 60.8819 122.224 61.4638 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 122.224C72.5828 122.224 73.0546 121.753 73.0546 121.171C73.0546 120.589 72.5828 120.117 72.0009 120.117C71.419 120.117 70.9473 120.589 70.9473 121.171C70.9473 121.753 71.419 122.224 72.0009 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 122.224C83.118 122.224 83.5897 121.753 83.5897 121.171C83.5897 120.589 83.118 120.117 82.5361 120.117C81.9542 120.117 81.4824 120.589 81.4824 121.171C81.4824 121.753 81.9542 122.224 82.5361 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 122.224C90.1434 122.224 90.6151 121.753 90.6151 121.171C90.6151 120.589 90.1434 120.117 89.5615 120.117C88.9796 120.117 88.5078 120.589 88.5078 121.171C88.5078 121.753 88.9796 122.224 89.5615 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 122.224C100.679 122.224 101.15 121.753 101.15 121.171C101.15 120.589 100.679 120.117 100.097 120.117C99.5147 120.117 99.043 120.589 99.043 121.171C99.043 121.753 99.5147 122.224 100.097 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 122.224C107.704 122.224 108.176 121.753 108.176 121.171C108.176 120.589 107.704 120.117 107.122 120.117C106.54 120.117 106.068 120.589 106.068 121.171C106.068 121.753 106.54 122.224 107.122 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 122.224C111.216 122.224 111.687 121.753 111.687 121.171C111.687 120.589 111.216 120.117 110.634 120.117C110.052 120.117 109.58 120.589 109.58 121.171C109.58 121.753 110.052 122.224 110.634 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 122.224C114.727 122.224 115.199 121.753 115.199 121.171C115.199 120.589 114.727 120.117 114.145 120.117C113.564 120.117 113.092 120.589 113.092 121.171C113.092 121.753 113.564 122.224 114.145 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 122.224C118.241 122.224 118.713 121.753 118.713 121.171C118.713 120.589 118.241 120.117 117.659 120.117C117.077 120.117 116.605 120.589 116.605 121.171C116.605 121.753 117.077 122.224 117.659 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 122.224C121.753 122.224 122.225 121.753 122.225 121.171C122.225 120.589 121.753 120.117 121.171 120.117C120.589 120.117 120.117 120.589 120.117 121.171C120.117 121.753 120.589 122.224 121.171 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.683 122.224C125.264 122.224 125.736 121.753 125.736 121.171C125.736 120.589 125.264 120.117 124.683 120.117C124.101 120.117 123.629 120.589 123.629 121.171C123.629 121.753 124.101 122.224 124.683 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 122.224C132.29 122.224 132.762 121.753 132.762 121.171C132.762 120.589 132.29 120.117 131.708 120.117C131.126 120.117 130.654 120.589 130.654 121.171C130.654 121.753 131.126 122.224 131.708 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 122.224C135.802 122.224 136.273 121.753 136.273 121.171C136.273 120.589 135.802 120.117 135.22 120.117C134.638 120.117 134.166 120.589 134.166 121.171C134.166 121.753 134.638 122.224 135.22 122.224Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 125.737C37.4598 125.737 37.9315 125.265 37.9315 124.683C37.9315 124.101 37.4598 123.629 36.8779 123.629C36.296 123.629 35.8242 124.101 35.8242 124.683C35.8242 125.265 36.296 125.737 36.8779 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 125.737C40.9715 125.737 41.4433 125.265 41.4433 124.683C41.4433 124.101 40.9715 123.629 40.3896 123.629C39.8077 123.629 39.3359 124.101 39.3359 124.683C39.3359 125.265 39.8077 125.737 40.3896 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 125.737C44.4852 125.737 44.9569 125.265 44.9569 124.683C44.9569 124.101 44.4852 123.629 43.9033 123.629C43.3213 123.629 42.8496 124.101 42.8496 124.683C42.8496 125.265 43.3213 125.737 43.9033 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 125.737C47.9969 125.737 48.4686 125.265 48.4686 124.683C48.4686 124.101 47.9969 123.629 47.415 123.629C46.8331 123.629 46.3613 124.101 46.3613 124.683C46.3613 125.265 46.8331 125.737 47.415 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 125.737C55.0203 125.737 55.4921 125.265 55.4921 124.683C55.4921 124.101 55.0203 123.629 54.4384 123.629C53.8565 123.629 53.3848 124.101 53.3848 124.683C53.3848 125.265 53.8565 125.737 54.4384 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 125.737C62.0457 125.737 62.5175 125.265 62.5175 124.683C62.5175 124.101 62.0457 123.629 61.4638 123.629C60.8819 123.629 60.4102 124.101 60.4102 124.683C60.4102 125.265 60.8819 125.737 61.4638 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 125.737C72.5828 125.737 73.0546 125.265 73.0546 124.683C73.0546 124.101 72.5828 123.629 72.0009 123.629C71.419 123.629 70.9473 124.101 70.9473 124.683C70.9473 125.265 71.419 125.737 72.0009 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 125.737C76.0946 125.737 76.5663 125.265 76.5663 124.683C76.5663 124.101 76.0946 123.629 75.5126 123.629C74.9307 123.629 74.459 124.101 74.459 124.683C74.459 125.265 74.9307 125.737 75.5126 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 125.737C79.6063 125.737 80.078 125.265 80.078 124.683C80.078 124.101 79.6063 123.629 79.0244 123.629C78.4424 123.629 77.9707 124.101 77.9707 124.683C77.9707 125.265 78.4424 125.737 79.0244 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5361 125.737C83.118 125.737 83.5897 125.265 83.5897 124.683C83.5897 124.101 83.118 123.629 82.5361 123.629C81.9542 123.629 81.4824 124.101 81.4824 124.683C81.4824 125.265 81.9542 125.737 82.5361 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 125.737C90.1434 125.737 90.6151 125.265 90.6151 124.683C90.6151 124.101 90.1434 123.629 89.5615 123.629C88.9796 123.629 88.5078 124.101 88.5078 124.683C88.5078 125.265 88.9796 125.737 89.5615 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.122 125.737C107.704 125.737 108.176 125.265 108.176 124.683C108.176 124.101 107.704 123.629 107.122 123.629C106.54 123.629 106.068 124.101 106.068 124.683C106.068 125.265 106.54 125.737 107.122 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.634 125.737C111.216 125.737 111.687 125.265 111.687 124.683C111.687 124.101 111.216 123.629 110.634 123.629C110.052 123.629 109.58 124.101 109.58 124.683C109.58 125.265 110.052 125.737 110.634 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 125.737C114.727 125.737 115.199 125.265 115.199 124.683C115.199 124.101 114.727 123.629 114.145 123.629C113.564 123.629 113.092 124.101 113.092 124.683C113.092 125.265 113.564 125.737 114.145 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 125.737C121.753 125.737 122.225 125.265 122.225 124.683C122.225 124.101 121.753 123.629 121.171 123.629C120.589 123.629 120.117 124.101 120.117 124.683C120.117 125.265 120.589 125.737 121.171 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 125.737C135.802 125.737 136.273 125.265 136.273 124.683C136.273 124.101 135.802 123.629 135.22 123.629C134.638 123.629 134.166 124.101 134.166 124.683C134.166 125.265 134.638 125.737 135.22 125.737Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 129.249C37.4598 129.249 37.9315 128.777 37.9315 128.195C37.9315 127.613 37.4598 127.142 36.8779 127.142C36.296 127.142 35.8242 127.613 35.8242 128.195C35.8242 128.777 36.296 129.249 36.8779 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 129.249C40.9715 129.249 41.4433 128.777 41.4433 128.195C41.4433 127.613 40.9715 127.142 40.3896 127.142C39.8077 127.142 39.3359 127.613 39.3359 128.195C39.3359 128.777 39.8077 129.249 40.3896 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 129.249C47.9969 129.249 48.4686 128.777 48.4686 128.195C48.4686 127.613 47.9969 127.142 47.415 127.142C46.8331 127.142 46.3613 127.613 46.3613 128.195C46.3613 128.777 46.8331 129.249 47.415 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 129.249C58.534 129.249 59.0058 128.777 59.0058 128.195C59.0058 127.613 58.534 127.142 57.9521 127.142C57.3702 127.142 56.8984 127.613 56.8984 128.195C56.8984 128.777 57.3702 129.249 57.9521 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 129.249C65.5575 129.249 66.0292 128.777 66.0292 128.195C66.0292 127.613 65.5575 127.142 64.9755 127.142C64.3936 127.142 63.9219 127.613 63.9219 128.195C63.9219 128.777 64.3936 129.249 64.9755 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 129.249C79.6063 129.249 80.078 128.777 80.078 128.195C80.078 127.613 79.6063 127.142 79.0244 127.142C78.4424 127.142 77.9707 127.613 77.9707 128.195C77.9707 128.777 78.4424 129.249 79.0244 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 129.249C90.1434 129.249 90.6151 128.777 90.6151 128.195C90.6151 127.613 90.1434 127.142 89.5615 127.142C88.9796 127.142 88.5078 127.613 88.5078 128.195C88.5078 128.777 88.9796 129.249 89.5615 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 129.249C97.1668 129.249 97.6386 128.777 97.6386 128.195C97.6386 127.613 97.1668 127.142 96.5849 127.142C96.003 127.142 95.5312 127.613 95.5312 128.195C95.5312 128.777 96.003 129.249 96.5849 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 129.249C100.679 129.249 101.15 128.777 101.15 128.195C101.15 127.613 100.679 127.142 100.097 127.142C99.5147 127.142 99.043 127.613 99.043 128.195C99.043 128.777 99.5147 129.249 100.097 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 129.249C114.727 129.249 115.199 128.777 115.199 128.195C115.199 127.613 114.727 127.142 114.145 127.142C113.564 127.142 113.092 127.613 113.092 128.195C113.092 128.777 113.564 129.249 114.145 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 129.249C121.753 129.249 122.225 128.777 122.225 128.195C122.225 127.613 121.753 127.142 121.171 127.142C120.589 127.142 120.117 127.613 120.117 128.195C120.117 128.777 120.589 129.249 121.171 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 129.249C128.776 129.249 129.248 128.777 129.248 128.195C129.248 127.613 128.776 127.142 128.194 127.142C127.612 127.142 127.141 127.613 127.141 128.195C127.141 128.777 127.612 129.249 128.194 129.249Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 132.761C44.4852 132.761 44.9569 132.289 44.9569 131.707C44.9569 131.125 44.4852 130.654 43.9033 130.654C43.3213 130.654 42.8496 131.125 42.8496 131.707C42.8496 132.289 43.3213 132.761 43.9033 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 132.761C47.9969 132.761 48.4686 132.289 48.4686 131.707C48.4686 131.125 47.9969 130.654 47.415 130.654C46.8331 130.654 46.3613 131.125 46.3613 131.707C46.3613 132.289 46.8331 132.761 47.415 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 132.761C55.0203 132.761 55.4921 132.289 55.4921 131.707C55.4921 131.125 55.0203 130.654 54.4384 130.654C53.8565 130.654 53.3848 131.125 53.3848 131.707C53.3848 132.289 53.8565 132.761 54.4384 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9755 132.761C65.5575 132.761 66.0292 132.289 66.0292 131.707C66.0292 131.125 65.5575 130.654 64.9755 130.654C64.3936 130.654 63.9219 131.125 63.9219 131.707C63.9219 132.289 64.3936 132.761 64.9755 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0009 132.761C72.5828 132.761 73.0546 132.289 73.0546 131.707C73.0546 131.125 72.5828 130.654 72.0009 130.654C71.419 130.654 70.9473 131.125 70.9473 131.707C70.9473 132.289 71.419 132.761 72.0009 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0244 132.761C79.6063 132.761 80.078 132.289 80.078 131.707C80.078 131.125 79.6063 130.654 79.0244 130.654C78.4424 130.654 77.9707 131.125 77.9707 131.707C77.9707 132.289 78.4424 132.761 79.0244 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.0498 132.761C86.6317 132.761 87.1034 132.289 87.1034 131.707C87.1034 131.125 86.6317 130.654 86.0498 130.654C85.4678 130.654 84.9961 131.125 84.9961 131.707C84.9961 132.289 85.4678 132.761 86.0498 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5615 132.761C90.1434 132.761 90.6151 132.289 90.6151 131.707C90.6151 131.125 90.1434 130.654 89.5615 130.654C88.9796 130.654 88.5078 131.125 88.5078 131.707C88.5078 132.289 88.9796 132.761 89.5615 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 132.761C93.6551 132.761 94.1268 132.289 94.1268 131.707C94.1268 131.125 93.6551 130.654 93.0732 130.654C92.4913 130.654 92.0195 131.125 92.0195 131.707C92.0195 132.289 92.4913 132.761 93.0732 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 132.761C97.1668 132.761 97.6386 132.289 97.6386 131.707C97.6386 131.125 97.1668 130.654 96.5849 130.654C96.003 130.654 95.5312 131.125 95.5312 131.707C95.5312 132.289 96.003 132.761 96.5849 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 132.761C100.679 132.761 101.15 132.289 101.15 131.707C101.15 131.125 100.679 130.654 100.097 130.654C99.5147 130.654 99.043 131.125 99.043 131.707C99.043 132.289 99.5147 132.761 100.097 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 132.761C104.192 132.761 104.664 132.289 104.664 131.707C104.664 131.125 104.192 130.654 103.61 130.654C103.028 130.654 102.557 131.125 102.557 131.707C102.557 132.289 103.028 132.761 103.61 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.659 132.761C118.241 132.761 118.713 132.289 118.713 131.707C118.713 131.125 118.241 130.654 117.659 130.654C117.077 130.654 116.605 131.125 116.605 131.707C116.605 132.289 117.077 132.761 117.659 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 132.761C121.753 132.761 122.225 132.289 122.225 131.707C122.225 131.125 121.753 130.654 121.171 130.654C120.589 130.654 120.117 131.125 120.117 131.707C120.117 132.289 120.589 132.761 121.171 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 132.761C128.776 132.761 129.248 132.289 129.248 131.707C129.248 131.125 128.776 130.654 128.194 130.654C127.612 130.654 127.141 131.125 127.141 131.707C127.141 132.289 127.612 132.761 128.194 132.761Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8779 136.273C37.4598 136.273 37.9315 135.801 37.9315 135.22C37.9315 134.638 37.4598 134.166 36.8779 134.166C36.296 134.166 35.8242 134.638 35.8242 135.22C35.8242 135.801 36.296 136.273 36.8779 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.3896 136.273C40.9715 136.273 41.4433 135.801 41.4433 135.22C41.4433 134.638 40.9715 134.166 40.3896 134.166C39.8077 134.166 39.3359 134.638 39.3359 135.22C39.3359 135.801 39.8077 136.273 40.3896 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9033 136.273C44.4852 136.273 44.9569 135.801 44.9569 135.22C44.9569 134.638 44.4852 134.166 43.9033 134.166C43.3213 134.166 42.8496 134.638 42.8496 135.22C42.8496 135.801 43.3213 136.273 43.9033 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.415 136.273C47.9969 136.273 48.4686 135.801 48.4686 135.22C48.4686 134.638 47.9969 134.166 47.415 134.166C46.8331 134.166 46.3613 134.638 46.3613 135.22C46.3613 135.801 46.8331 136.273 47.415 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4384 136.273C55.0203 136.273 55.4921 135.801 55.4921 135.22C55.4921 134.638 55.0203 134.166 54.4384 134.166C53.8565 134.166 53.3848 134.638 53.3848 135.22C53.3848 135.801 53.8565 136.273 54.4384 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9521 136.273C58.534 136.273 59.0058 135.801 59.0058 135.22C59.0058 134.638 58.534 134.166 57.9521 134.166C57.3702 134.166 56.8984 134.638 56.8984 135.22C56.8984 135.801 57.3702 136.273 57.9521 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.4638 136.273C62.0457 136.273 62.5175 135.801 62.5175 135.22C62.5175 134.638 62.0457 134.166 61.4638 134.166C60.8819 134.166 60.4102 134.638 60.4102 135.22C60.4102 135.801 60.8819 136.273 61.4638 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4873 136.273C69.0692 136.273 69.5409 135.801 69.5409 135.22C69.5409 134.638 69.0692 134.166 68.4873 134.166C67.9053 134.166 67.4336 134.638 67.4336 135.22C67.4336 135.801 67.9053 136.273 68.4873 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5126 136.273C76.0946 136.273 76.5663 135.801 76.5663 135.22C76.5663 134.638 76.0946 134.166 75.5126 134.166C74.9307 134.166 74.459 134.638 74.459 135.22C74.459 135.801 74.9307 136.273 75.5126 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0732 136.273C93.6551 136.273 94.1268 135.801 94.1268 135.22C94.1268 134.638 93.6551 134.166 93.0732 134.166C92.4913 134.166 92.0195 134.638 92.0195 135.22C92.0195 135.801 92.4913 136.273 93.0732 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5849 136.273C97.1668 136.273 97.6386 135.801 97.6386 135.22C97.6386 134.638 97.1668 134.166 96.5849 134.166C96.003 134.166 95.5312 134.638 95.5312 135.22C95.5312 135.801 96.003 136.273 96.5849 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.097 136.273C100.679 136.273 101.15 135.801 101.15 135.22C101.15 134.638 100.679 134.166 100.097 134.166C99.5147 134.166 99.043 134.638 99.043 135.22C99.043 135.801 99.5147 136.273 100.097 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.61 136.273C104.192 136.273 104.664 135.801 104.664 135.22C104.664 134.638 104.192 134.166 103.61 134.166C103.028 134.166 102.557 134.638 102.557 135.22C102.557 135.801 103.028 136.273 103.61 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.145 136.273C114.727 136.273 115.199 135.801 115.199 135.22C115.199 134.638 114.727 134.166 114.145 134.166C113.564 134.166 113.092 134.638 113.092 135.22C113.092 135.801 113.564 136.273 114.145 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.171 136.273C121.753 136.273 122.225 135.801 122.225 135.22C122.225 134.638 121.753 134.166 121.171 134.166C120.589 134.166 120.117 134.638 120.117 135.22C120.117 135.801 120.589 136.273 121.171 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.194 136.273C128.776 136.273 129.248 135.801 129.248 135.22C129.248 134.638 128.776 134.166 128.194 134.166C127.612 134.166 127.141 134.638 127.141 135.22C127.141 135.801 127.612 136.273 128.194 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.708 136.273C132.29 136.273 132.762 135.801 132.762 135.22C132.762 134.638 132.29 134.166 131.708 134.166C131.126 134.166 130.654 134.638 130.654 135.22C130.654 135.801 131.126 136.273 131.708 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.22 136.273C135.802 136.273 136.273 135.801 136.273 135.22C136.273 134.638 135.802 134.166 135.22 134.166C134.638 134.166 134.166 134.638 134.166 135.22C134.166 135.801 134.638 136.273 135.22 136.273Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2151 7.02637H15.4171C11.6167 7.02637 8.39702 9.53727 7.36763 12.9691C7.26118 13.3242 7.17808 13.689 7.1203 14.062C7.05663 14.4735 7.02344 14.8949 7.02344 15.3239V23.307C7.02344 27.8846 10.7899 31.6071 15.4171 31.6071L19.3161 31.6078L23.2151 31.6068C27.8421 31.6068 31.6088 27.8843 31.6088 23.3068V15.3239C31.6088 10.7486 27.8423 7.02637 23.2151 7.02637ZM27.921 23.307C27.921 25.8502 25.8101 27.9193 23.2141 27.9193L19.3161 27.92L15.4181 27.919C12.8221 27.919 10.7112 25.8499 10.7112 23.307V15.3239C10.7112 14.5296 10.9173 13.7817 11.2799 13.1282C11.629 12.4996 12.1229 11.9589 12.7177 11.5496C13.4823 11.0232 14.4133 10.7142 15.4169 10.7142H23.2151C25.8101 10.7142 27.921 12.782 27.921 15.3239V23.307Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.582 7.02637H120.784C116.984 7.02637 113.764 9.53727 112.735 12.9691C112.628 13.3242 112.545 13.689 112.487 14.062C112.424 14.4735 112.391 14.8949 112.391 15.3239V23.307C112.391 27.8846 116.157 31.6071 120.784 31.6071L124.683 31.6078L128.582 31.6068C133.209 31.6068 136.976 27.8843 136.976 23.3068V15.3239C136.976 10.7486 133.21 7.02637 128.582 7.02637ZM133.288 23.307C133.288 25.8502 131.177 27.9193 128.581 27.9193L124.683 27.92L120.785 27.919C118.189 27.919 116.078 25.8499 116.078 23.307V15.3239C116.078 14.5296 116.284 13.7817 116.647 13.1282C116.996 12.4996 117.49 11.9589 118.085 11.5496C118.849 11.0232 119.78 10.7142 120.784 10.7142H128.582C131.177 10.7142 133.288 12.782 133.288 15.3239V23.307Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2151 112.392H15.4171C11.6167 112.392 8.39702 114.903 7.36763 118.335C7.26118 118.69 7.17808 119.055 7.1203 119.428C7.05663 119.839 7.02344 120.261 7.02344 120.69V128.673C7.02344 133.25 10.7899 136.973 15.4171 136.973L19.3161 136.974L23.2151 136.973C27.8421 136.973 31.6088 133.25 31.6088 128.673V120.69C31.6088 116.114 27.8423 112.392 23.2151 112.392ZM27.921 128.673C27.921 131.216 25.8101 133.285 23.2141 133.285L19.3161 133.286L15.4181 133.285C12.8221 133.285 10.7112 131.216 10.7112 128.673V120.69C10.7112 119.895 10.9173 119.148 11.2799 118.494C11.629 117.865 12.1229 117.325 12.7177 116.915C13.4823 116.389 14.4133 116.08 15.4169 116.08H23.2151C25.8101 116.08 27.921 118.148 27.921 120.69V128.673Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5854 14.0488H14.0488V24.5854H24.5854V14.0488Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.951 14.0488H119.414V24.5854H129.951V14.0488Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5854 119.415H14.0488V129.951H24.5854V119.415Z",
			fill: "black"
		})
	]
});
export default SvgQrCode;
